// Mock data for Fatima Abdulqudous Al Obeidli Law Office

export const officeInfo = {
  name: {
    ar: "مكتب فاطمة عبدالقدوس العبيدلي للمحاماة والاستشارات القانونية",
    en: "Fatima Abdulqudous Al Obeidli Law Office",
    zh: "法蒂玛·阿卜杜勒库杜斯·阿尔奥贝德利律师事务所",
    ru: "Юридическая контора Фатимы Абдулкудус Аль Обейдли",
    hi: "फातिमा अब्दुलकुदूस अल ओबैदली लॉ ऑफिस",
    es: "Bufete de Abogados Fatima Abdulqudous Al Obeidli",
    fr: "Cabinet d'avocats Fatima Abdulqudous Al Obeidli"
  },
  address: "Corniche Plaza 1 - 3rd Floor - Office # 302 - Corniche St - Al Majaz 1 - Sharjah - United Arab Emirates",
  phone: "+971 50 206 0230",
  email: "fatimaabdelqudous@gmail.com",
  hours: {
    ar: "السبت - الخميس: 8:30 صباحاً - 5:00 مساءً",
    en: "Saturday - Thursday: 8:30 AM - 5:00 PM",
    zh: "周六至周四：上午 8:30 - 下午 5:00",
    ru: "Суббота - Четверг: 8:30 - 17:00",
    hi: "शनिवार - गुरुवार: सुबह 8:30 - शाम 5:00",
    es: "Sábado - Jueves: 8:30 AM - 5:00 PM",
    fr: "Samedi - Jeudi: 8h30 - 17h00"
  },
  mapUrl: "https://maps.app.goo.gl/HrVRSJAGrrRrb8wX6"
};

export const translations = {
  ar: {
    // Header
    home: "الرئيسية",
    about: "من نحن",
    services: "خدماتنا",
    team: "فريقنا",
    testimonials: "آراء العملاء",
    contact: "اتصل بنا",
    
    // Hero
    heroTitle: "التميز القانوني مع خبرة يمكنك الوثوق بها",
    heroSubtitle: "استشارات قانونية متخصصة وتمثيل قضائي محترف في جميع المجالات القانونية",
    heroButton: "احجز استشارة",
    
    // About
    aboutTitle: "عن مكتب المحامية فاطمة عبدالقدوس العبيدلي",
    aboutDescription: "مكتب قانوني رائد في الإمارات متخصص في تقديم خدمات قانونية شاملة للأفراد والشركات. نفخر بتقديم استشارات قانونية متميزة وتمثيل قضائي احترافي بأعلى معايير الجودة.",
    aboutYears: "سنوات من الخبرة",
    aboutCases: "قضية ناجحة",
    aboutClients: "عميل راض",
    
    // Services
    servicesTitle: "خدماتنا القانونية",
    servicesSubtitle: "نقدم مجموعة شاملة من الخدمات القانونية المتخصصة",
    
    service1Title: "القانون التجاري",
    service1Desc: "استشارات قانونية شاملة للشركات والأعمال التجارية",
    
    service2Title: "القانون المدني",
    service2Desc: "تمثيل قانوني في القضايا المدنية والنزاعات",
    
    service3Title: "قانون الأسرة",
    service3Desc: "حلول قانونية حساسة لقضايا الأسرة والأحوال الشخصية",
    
    service4Title: "القانون العقاري",
    service4Desc: "خدمات قانونية متكاملة في المعاملات العقارية",
    
    service5Title: "القانون الجنائي",
    service5Desc: "دفاع قوي ومتخصص في القضايا الجنائية",
    
    service6Title: "قانون العمل",
    service6Desc: "حماية حقوق العمال وأصحاب العمل",
    
    // Team
    teamTitle: "فريقنا القانوني",
    teamSubtitle: "محامون متخصصون ومستشارون قانونيون ذوو خبرة",
    teamRole: "المحامية المؤسسة",
    teamBio: "محامية متميزة بخبرة واسعة في مختلف المجالات القانونية، ملتزمة بتقديم أفضل الخدمات القانونية لعملائها",
    
    // Testimonials
    testimonialsTitle: "آراء عملائنا",
    testimonialsSubtitle: "ثقة عملائنا هي أكبر إنجازاتنا",
    
    testimonial1: "خدمة قانونية متميزة واحترافية عالية. ساعدوني في حل قضيتي بكفاءة ومهنية",
    testimonial1Name: "أحمد المنصوري",
    testimonial1Role: "رجل أعمال",
    
    testimonial2: "فريق محترف وودود. أنصح بشدة بخدماتهم القانونية المتميزة",
    testimonial2Name: "سارة الشامسي",
    testimonial2Role: "مديرة شركة",
    
    testimonial3: "خبرة قانونية رائعة ونتائج ممتازة. شكراً على الدعم المستمر",
    testimonial3Name: "محمد الكعبي",
    testimonial3Role: "مستثمر",
    
    // Contact
    contactTitle: "تواصل معنا",
    contactSubtitle: "نحن هنا لمساعدتك في احتياجاتك القانونية",
    contactName: "الاسم الكامل",
    contactEmail: "البريد الإلكتروني",
    contactPhone: "رقم الهاتف",
    contactMessage: "رسالتك",
    contactButton: "إرسال الرسالة",
    contactSuccess: "تم إرسال رسالتك بنجاح! سنتواصل معك قريباً",
    
    // Footer
    footerAbout: "نحن",
    footerAboutText: "مكتب قانوني متخصص في تقديم خدمات قانونية شاملة ومتميزة في الإمارات",
    footerQuickLinks: "روابط سريعة",
    footerContact: "معلومات الاتصال",
    footerRights: "جميع الحقوق محفوظة",
    
    // Why Choose Us
    whyTitle: "لماذا تختارنا",
    whySubtitle: "التزامنا بالتميز والاحترافية",
    why1Title: "خبرة متخصصة",
    why1Desc: "فريق من المحامين ذوي الخبرة الواسعة",
    why2Title: "نتائج مثبتة",
    why2Desc: "سجل حافل بالقضايا الناجحة",
    why3Title: "نهج شخصي",
    why3Desc: "حلول قانونية مخصصة لكل عميل",
    why4Title: "متاح دائماً",
    why4Desc: "دعم ومتابعة مستمرة لعملائنا"
  },
  en: {
    // Header
    home: "Home",
    about: "About",
    services: "Services",
    team: "Team",
    testimonials: "Testimonials",
    contact: "Contact",
    
    // Hero
    heroTitle: "Legal Excellence with Trusted Expertise",
    heroSubtitle: "Professional legal consultation and representation across all areas of law",
    heroButton: "Book Consultation",
    
    // About
    aboutTitle: "About Advocate Fatima Abdulqudous Al Obeidli",
    aboutDescription: "A leading law firm in the UAE specializing in comprehensive legal services for individuals and businesses. We pride ourselves on providing exceptional legal consultation and professional representation to the highest standards.",
    aboutYears: "Years of Experience",
    aboutCases: "Successful Cases",
    aboutClients: "Satisfied Clients",
    
    // Services
    servicesTitle: "Our Legal Services",
    servicesSubtitle: "We offer a comprehensive range of specialized legal services",
    
    service1Title: "Commercial Law",
    service1Desc: "Comprehensive legal consultation for companies and commercial businesses",
    
    service2Title: "Civil Law",
    service2Desc: "Legal representation in civil cases and disputes",
    
    service3Title: "Family Law",
    service3Desc: "Sensitive legal solutions for family and personal status matters",
    
    service4Title: "Real Estate Law",
    service4Desc: "Comprehensive legal services in real estate transactions",
    
    service5Title: "Criminal Law",
    service5Desc: "Strong and specialized defense in criminal cases",
    
    service6Title: "Labor Law",
    service6Desc: "Protection of employee and employer rights",
    
    // Team
    teamTitle: "Our Legal Team",
    teamSubtitle: "Specialized lawyers and experienced legal consultants",
    teamRole: "Founder & Lead Advocate",
    teamBio: "A distinguished lawyer with extensive experience in various legal fields, committed to providing the best legal services to clients",
    
    // Testimonials
    testimonialsTitle: "Client Testimonials",
    testimonialsSubtitle: "Our clients' trust is our greatest achievement",
    
    testimonial1: "Exceptional and highly professional legal service. They helped me resolve my case efficiently and professionally",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Businessman",
    
    testimonial2: "Professional and friendly team. Highly recommend their outstanding legal services",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Company Director",
    
    testimonial3: "Excellent legal expertise and outstanding results. Thank you for the continuous support",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Investor",
    
    // Contact
    contactTitle: "Contact Us",
    contactSubtitle: "We're here to help with your legal needs",
    contactName: "Full Name",
    contactEmail: "Email Address",
    contactPhone: "Phone Number",
    contactMessage: "Your Message",
    contactButton: "Send Message",
    contactSuccess: "Your message has been sent successfully! We'll contact you soon",
    
    // Footer
    footerAbout: "About Us",
    footerAboutText: "A specialized law firm providing comprehensive and distinguished legal services in the UAE",
    footerQuickLinks: "Quick Links",
    footerContact: "Contact Information",
    footerRights: "All Rights Reserved",
    
    // Why Choose Us
    whyTitle: "Why Choose Us",
    whySubtitle: "Our commitment to excellence and professionalism",
    why1Title: "Specialized Expertise",
    why1Desc: "Team of lawyers with extensive experience",
    why2Title: "Proven Results",
    why2Desc: "Track record of successful cases",
    why3Title: "Personal Approach",
    why3Desc: "Customized legal solutions for each client",
    why4Title: "Always Available",
    why4Desc: "Continuous support and follow-up for our clients"
  },
  zh: {
    home: "首页",
    about: "关于我们",
    services: "服务",
    team: "团队",
    testimonials: "客户评价",
    contact: "联系我们",
    heroTitle: "值得信赖的卓越法律服务",
    heroSubtitle: "提供全方位专业法律咨询和代理服务",
    heroButton: "预约咨询",
    aboutTitle: "关于律师法蒂玛·阿卜杜勒库杜斯·阿尔奥贝德利",
    aboutDescription: "阿联酋领先的律师事务所，专门为个人和企业提供全面的法律服务。我们以提供卓越的法律咨询和专业代理服务为荣。",
    aboutYears: "年经验",
    aboutCases: "成功案例",
    aboutClients: "满意客户",
    servicesTitle: "我们的法律服务",
    servicesSubtitle: "提供全面的专业法律服务",
    service1Title: "商业法",
    service1Desc: "为公司和商业企业提供全面的法律咨询",
    service2Title: "民法",
    service2Desc: "民事案件和纠纷的法律代理",
    service3Title: "家庭法",
    service3Desc: "家庭和个人身份事务的敏感法律解决方案",
    service4Title: "房地产法",
    service4Desc: "房地产交易的综合法律服务",
    service5Title: "刑法",
    service5Desc: "刑事案件的强有力专业辩护",
    service6Title: "劳动法",
    service6Desc: "保护员工和雇主的权利",
    teamTitle: "我们的法律团队",
    teamSubtitle: "专业律师和经验丰富的法律顾问",
    teamRole: "创始人兼首席律师",
    teamBio: "杰出的律师，在各个法律领域拥有丰富的经验，致力于为客户提供最佳法律服务",
    testimonialsTitle: "客户评价",
    testimonialsSubtitle: "客户的信任是我们最大的成就",
    testimonial1: "卓越且高度专业的法律服务。他们高效专业地帮助我解决了案件",
    testimonial1Name: "艾哈迈德·曼苏里",
    testimonial1Role: "商人",
    testimonial2: "专业友好的团队。强烈推荐他们出色的法律服务",
    testimonial2Name: "萨拉·沙姆西",
    testimonial2Role: "公司董事",
    testimonial3: "优秀的法律专业知识和出色的成果。感谢持续的支持",
    testimonial3Name: "穆罕默德·卡比",
    testimonial3Role: "投资者",
    contactTitle: "联系我们",
    contactSubtitle: "我们随时为您的法律需求提供帮助",
    contactName: "全名",
    contactEmail: "电子邮件",
    contactPhone: "电话号码",
    contactMessage: "您的留言",
    contactButton: "发送消息",
    contactSuccess: "您的消息已成功发送！我们很快会与您联系",
    footerAbout: "关于我们",
    footerAboutText: "在阿联酋提供全面卓越法律服务的专业律师事务所",
    footerQuickLinks: "快速链接",
    footerContact: "联系信息",
    footerRights: "版权所有",
    whyTitle: "为什么选择我们",
    whySubtitle: "我们对卓越和专业的承诺",
    why1Title: "专业知识",
    why1Desc: "经验丰富的律师团队",
    why2Title: "成功记录",
    why2Desc: "成功案例记录",
    why3Title: "个性化方法",
    why3Desc: "为每位客户量身定制的法律解决方案",
    why4Title: "随时可用",
    why4Desc: "为客户提供持续支持和跟进"
  },
  ru: {
    home: "Главная",
    about: "О нас",
    services: "Услуги",
    team: "Команда",
    testimonials: "Отзывы",
    contact: "Контакты",
    heroTitle: "Юридическое превосходство с проверенным опытом",
    heroSubtitle: "Профессиональная юридическая консультация и представительство во всех областях права",
    heroButton: "Записаться на консультацию",
    aboutTitle: "О адвокате Фатиме Абдулкудус Аль Обейдли",
    aboutDescription: "Ведущая юридическая фирма в ОАЭ, специализирующаяся на комплексных юридических услугах для физических и юридических лиц. Мы гордимся предоставлением исключительных юридических консультаций и профессионального представительства на высочайшем уровне.",
    aboutYears: "Лет опыта",
    aboutCases: "Успешных дел",
    aboutClients: "Довольных клиентов",
    servicesTitle: "Наши юридические услуги",
    servicesSubtitle: "Мы предлагаем полный спектр специализированных юридических услуг",
    service1Title: "Коммерческое право",
    service1Desc: "Комплексные юридические консультации для компаний и коммерческих предприятий",
    service2Title: "Гражданское право",
    service2Desc: "Юридическое представительство в гражданских делах и спорах",
    service3Title: "Семейное право",
    service3Desc: "Деликатные юридические решения по семейным вопросам и личному статусу",
    service4Title: "Недвижимость",
    service4Desc: "Комплексные юридические услуги в сделках с недвижимостью",
    service5Title: "Уголовное право",
    service5Desc: "Сильная и специализированная защита в уголовных делах",
    service6Title: "Трудовое право",
    service6Desc: "Защита прав работников и работодателей",
    teamTitle: "Наша юридическая команда",
    teamSubtitle: "Специализированные юристы и опытные юридические консультанты",
    teamRole: "Основатель и главный адвокат",
    teamBio: "Выдающийся юрист с обширным опытом в различных областях права, стремящийся предоставить клиентам лучшие юридические услуги",
    testimonialsTitle: "Отзывы клиентов",
    testimonialsSubtitle: "Доверие наших клиентов — наше главное достижение",
    testimonial1: "Исключительное и высокопрофессиональное юридическое обслуживание. Они помогли мне эффективно и профессионально решить мое дело",
    testimonial1Name: "Ахмед Аль Мансури",
    testimonial1Role: "Бизнесмен",
    testimonial2: "Профессиональная и дружелюбная команда. Настоятельно рекомендую их выдающиеся юридические услуги",
    testimonial2Name: "Сара Аль Шамси",
    testimonial2Role: "Директор компании",
    testimonial3: "Отличная юридическая экспертиза и выдающиеся результаты. Спасибо за постоянную поддержку",
    testimonial3Name: "Мохаммед Аль Кааби",
    testimonial3Role: "Инвестор",
    contactTitle: "Свяжитесь с нами",
    contactSubtitle: "Мы здесь, чтобы помочь с вашими юридическими потребностями",
    contactName: "Полное имя",
    contactEmail: "Электронная почта",
    contactPhone: "Номер телефона",
    contactMessage: "Ваше сообщение",
    contactButton: "Отправить сообщение",
    contactSuccess: "Ваше сообщение успешно отправлено! Мы скоро свяжемся с вами",
    footerAbout: "О нас",
    footerAboutText: "Специализированная юридическая фирма, предоставляющая комплексные и выдающиеся юридические услуги в ОАЭ",
    footerQuickLinks: "Быстрые ссылки",
    footerContact: "Контактная информация",
    footerRights: "Все права защищены",
    whyTitle: "Почему выбирают нас",
    whySubtitle: "Наша приверженность превосходству и профессионализму",
    why1Title: "Специализированный опыт",
    why1Desc: "Команда юристов с обширным опытом",
    why2Title: "Проверенные результаты",
    why2Desc: "Послужной список успешных дел",
    why3Title: "Личный подход",
    why3Desc: "Индивидуальные юридические решения для каждого клиента",
    why4Title: "Всегда доступны",
    why4Desc: "Постоянная поддержка и сопровождение наших клиентов"
  },
  hi: {
    home: "होम",
    about: "हमारे बारे में",
    services: "सेवाएं",
    team: "टीम",
    testimonials: "प्रशंसापत्र",
    contact: "संपर्क करें",
    heroTitle: "विश्वसनीय विशेषज्ञता के साथ कानूनी उत्कृष्टता",
    heroSubtitle: "कानून के सभी क्षेत्रों में पेशेवर कानूनी परामर्श और प्रतिनिधित्व",
    heroButton: "परामर्श बुक करें",
    aboutTitle: "अधिवक्ता फातिमा अब्दुलकुदूस अल ओबैदली के बारे में",
    aboutDescription: "यूएई में एक प्रमुख कानून फर्म जो व्यक्तियों और व्यवसायों के लिए व्यापक कानूनी सेवाओं में विशेषज्ञता रखती है। हम उच्चतम मानकों के अनुसार असाधारण कानूनी परामर्श और पेशेवर प्रतिनिधित्व प्रदान करने पर गर्व करते हैं।",
    aboutYears: "वर्षों का अनुभव",
    aboutCases: "सफल मामले",
    aboutClients: "संतुष्ट ग्राहक",
    servicesTitle: "हमारी कानूनी सेवाएं",
    servicesSubtitle: "हम विशेष कानूनी सेवाओं की एक व्यापक श्रृंखला प्रदान करते हैं",
    service1Title: "वाणिज्यिक कानून",
    service1Desc: "कंपनियों और वाणिज्यिक व्यवसायों के लिए व्यापक कानूनी परामर्श",
    service2Title: "नागरिक कानून",
    service2Desc: "नागरिक मामलों और विवादों में कानूनी प्रतिनिधित्व",
    service3Title: "पारिवारिक कानून",
    service3Desc: "पारिवारिक और व्यक्तिगत स्थिति मामलों के लिए संवेदनशील कानूनी समाधान",
    service4Title: "रियल एस्टेट कानून",
    service4Desc: "रियल एस्टेट लेनदेन में व्यापक कानूनी सेवाएं",
    service5Title: "आपराधिक कानून",
    service5Desc: "आपराधिक मामलों में मजबूत और विशेष बचाव",
    service6Title: "श्रम कानून",
    service6Desc: "कर्मचारी और नियोक्ता अधिकारों की सुरक्षा",
    teamTitle: "हमारी कानूनी टीम",
    teamSubtitle: "विशेष वकील और अनुभवी कानूनी सलाहकार",
    teamRole: "संस्थापक और प्रमुख अधिवक्ता",
    teamBio: "विभिन्न कानूनी क्षेत्रों में व्यापक अनुभव के साथ एक प्रतिष्ठित वकील, ग्राहकों को सर्वोत्तम कानूनी सेवाएं प्रदान करने के लिए प्रतिबद्ध",
    testimonialsTitle: "ग्राहक प्रशंसापत्र",
    testimonialsSubtitle: "हमारे ग्राहकों का विश्वास हमारी सबसे बड़ी उपलब्धि है",
    testimonial1: "असाधारण और अत्यधिक पेशेवर कानूनी सेवा। उन्होंने मुझे कुशलता और पेशेवर रूप से मेरे मामले को हल करने में मदद की",
    testimonial1Name: "अहमद अल मंसूरी",
    testimonial1Role: "व्यवसायी",
    testimonial2: "पेशेवर और मैत्रीपूर्ण टीम। उनकी उत्कृष्ट कानूनी सेवाओं की अत्यधिक अनुशंसा करते हैं",
    testimonial2Name: "सारा अल शमसी",
    testimonial2Role: "कंपनी निदेशक",
    testimonial3: "उत्कृष्ट कानूनी विशेषज्ञता और उत्कृष्ट परिणाम। निरंतर समर्थन के लिए धन्यवाद",
    testimonial3Name: "मोहम्मद अल काबी",
    testimonial3Role: "निवेशक",
    contactTitle: "हमसे संपर्क करें",
    contactSubtitle: "हम आपकी कानूनी आवश्यकताओं में मदद करने के लिए यहां हैं",
    contactName: "पूरा नाम",
    contactEmail: "ईमेल पता",
    contactPhone: "फोन नंबर",
    contactMessage: "आपका संदेश",
    contactButton: "संदेश भेजें",
    contactSuccess: "आपका संदेश सफलतापूर्वक भेज दिया गया है! हम जल्द ही आपसे संपर्क करेंगे",
    footerAbout: "हमारे बारे में",
    footerAboutText: "यूएई में व्यापक और विशिष्ट कानूनी सेवाएं प्रदान करने वाली एक विशेष कानून फर्म",
    footerQuickLinks: "त्वरित लिंक",
    footerContact: "संपर्क जानकारी",
    footerRights: "सर्वाधिकार सुरक्षित",
    whyTitle: "हमें क्यों चुनें",
    whySubtitle: "उत्कृष्टता और व्यावसायिकता के प्रति हमारी प्रतिबद्धता",
    why1Title: "विशेष विशेषज्ञता",
    why1Desc: "व्यापक अनुभव वाले वकीलों की टीम",
    why2Title: "सिद्ध परिणाम",
    why2Desc: "सफल मामलों का ट्रैक रिकॉर्ड",
    why3Title: "व्यक्तिगत दृष्टिकोण",
    why3Desc: "प्रत्येक ग्राहक के लिए अनुकूलित कानूनी समाधान",
    why4Title: "हमेशा उपलब्ध",
    why4Desc: "हमारे ग्राहकों के लिए निरंतर समर्थन और अनुवर्ती"
  },
  es: {
    home: "Inicio",
    about: "Acerca de",
    services: "Servicios",
    team: "Equipo",
    testimonials: "Testimonios",
    contact: "Contacto",
    heroTitle: "Excelencia Legal con Experiencia Confiable",
    heroSubtitle: "Consulta legal profesional y representación en todas las áreas del derecho",
    heroButton: "Reservar Consulta",
    aboutTitle: "Acerca de la Abogada Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Un bufete de abogados líder en los EAU especializado en servicios legales integrales para individuos y empresas. Nos enorgullecemos de proporcionar consultas legales excepcionales y representación profesional con los más altos estándares.",
    aboutYears: "Años de Experiencia",
    aboutCases: "Casos Exitosos",
    aboutClients: "Clientes Satisfechos",
    servicesTitle: "Nuestros Servicios Legales",
    servicesSubtitle: "Ofrecemos una gama completa de servicios legales especializados",
    service1Title: "Derecho Comercial",
    service1Desc: "Consulta legal integral para empresas y negocios comerciales",
    service2Title: "Derecho Civil",
    service2Desc: "Representación legal en casos civiles y disputas",
    service3Title: "Derecho Familiar",
    service3Desc: "Soluciones legales sensibles para asuntos familiares y de estado civil",
    service4Title: "Derecho Inmobiliario",
    service4Desc: "Servicios legales integrales en transacciones inmobiliarias",
    service5Title: "Derecho Penal",
    service5Desc: "Defensa fuerte y especializada en casos penales",
    service6Title: "Derecho Laboral",
    service6Desc: "Protección de los derechos de empleados y empleadores",
    teamTitle: "Nuestro Equipo Legal",
    teamSubtitle: "Abogados especializados y consultores legales experimentados",
    teamRole: "Fundadora y Abogada Principal",
    teamBio: "Una abogada distinguida con amplia experiencia en diversos campos legales, comprometida a proporcionar los mejores servicios legales a los clientes",
    testimonialsTitle: "Testimonios de Clientes",
    testimonialsSubtitle: "La confianza de nuestros clientes es nuestro mayor logro",
    testimonial1: "Servicio legal excepcional y altamente profesional. Me ayudaron a resolver mi caso de manera eficiente y profesional",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Empresario",
    testimonial2: "Equipo profesional y amigable. Recomiendo encarecidamente sus destacados servicios legales",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Directora de Empresa",
    testimonial3: "Excelente experiencia legal y resultados excepcionales. Gracias por el apoyo continuo",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Inversor",
    contactTitle: "Contáctenos",
    contactSubtitle: "Estamos aquí para ayudarlo con sus necesidades legales",
    contactName: "Nombre Completo",
    contactEmail: "Correo Electrónico",
    contactPhone: "Número de Teléfono",
    contactMessage: "Su Mensaje",
    contactButton: "Enviar Mensaje",
    contactSuccess: "¡Su mensaje ha sido enviado con éxito! Nos pondremos en contacto pronto",
    footerAbout: "Acerca de Nosotros",
    footerAboutText: "Un bufete de abogados especializado que proporciona servicios legales integrales y distinguidos en los EAU",
    footerQuickLinks: "Enlaces Rápidos",
    footerContact: "Información de Contacto",
    footerRights: "Todos los Derechos Reservados",
    whyTitle: "Por Qué Elegirnos",
    whySubtitle: "Nuestro compromiso con la excelencia y el profesionalismo",
    why1Title: "Experiencia Especializada",
    why1Desc: "Equipo de abogados con amplia experiencia",
    why2Title: "Resultados Probados",
    why2Desc: "Historial de casos exitosos",
    why3Title: "Enfoque Personal",
    why3Desc: "Soluciones legales personalizadas para cada cliente",
    why4Title: "Siempre Disponible",
    why4Desc: "Apoyo y seguimiento continuo para nuestros clientes"
  },
  fr: {
    home: "Accueil",
    about: "À propos",
    services: "Services",
    team: "Équipe",
    testimonials: "Témoignages",
    contact: "Contact",
    heroTitle: "Excellence Juridique avec une Expertise de Confiance",
    heroSubtitle: "Consultation juridique professionnelle et représentation dans tous les domaines du droit",
    heroButton: "Réserver une Consultation",
    aboutTitle: "À propos de l'Avocate Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Un cabinet d'avocats de premier plan aux EAU spécialisé dans les services juridiques complets pour les particuliers et les entreprises. Nous sommes fiers de fournir des consultations juridiques exceptionnelles et une représentation professionnelle aux normes les plus élevées.",
    aboutYears: "Années d'Expérience",
    aboutCases: "Cas Réussis",
    aboutClients: "Clients Satisfaits",
    servicesTitle: "Nos Services Juridiques",
    servicesSubtitle: "Nous offrons une gamme complète de services juridiques spécialisés",
    service1Title: "Droit Commercial",
    service1Desc: "Consultation juridique complète pour les entreprises et les commerces",
    service2Title: "Droit Civil",
    service2Desc: "Représentation juridique dans les affaires civiles et les litiges",
    service3Title: "Droit de la Famille",
    service3Desc: "Solutions juridiques sensibles pour les questions familiales et de statut personnel",
    service4Title: "Droit Immobilier",
    service4Desc: "Services juridiques complets dans les transactions immobilières",
    service5Title: "Droit Pénal",
    service5Desc: "Défense forte et spécialisée dans les affaires pénales",
    service6Title: "Droit du Travail",
    service6Desc: "Protection des droits des employés et des employeurs",
    teamTitle: "Notre Équipe Juridique",
    teamSubtitle: "Avocats spécialisés et consultants juridiques expérimentés",
    teamRole: "Fondatrice et Avocate Principale",
    teamBio: "Une avocate distinguée avec une vaste expérience dans divers domaines juridiques, engagée à fournir les meilleurs services juridiques aux clients",
    testimonialsTitle: "Témoignages de Clients",
    testimonialsSubtitle: "La confiance de nos clients est notre plus grande réalisation",
    testimonial1: "Service juridique exceptionnel et hautement professionnel. Ils m'ont aidé à résoudre mon cas efficacement et professionnellement",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Homme d'Affaires",
    testimonial2: "Équipe professionnelle et amicale. Je recommande vivement leurs excellents services juridiques",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Directrice d'Entreprise",
    testimonial3: "Excellente expertise juridique et résultats exceptionnels. Merci pour le soutien continu",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Investisseur",
    contactTitle: "Contactez-Nous",
    contactSubtitle: "Nous sommes là pour vous aider avec vos besoins juridiques",
    contactName: "Nom Complet",
    contactEmail: "Adresse Email",
    contactPhone: "Numéro de Téléphone",
    contactMessage: "Votre Message",
    contactButton: "Envoyer le Message",
    contactSuccess: "Votre message a été envoyé avec succès ! Nous vous contacterons bientôt",
    footerAbout: "À Propos de Nous",
    footerAboutText: "Un cabinet d'avocats spécialisé fournissant des services juridiques complets et distingués aux EAU",
    footerQuickLinks: "Liens Rapides",
    footerContact: "Informations de Contact",
    footerRights: "Tous Droits Réservés",
    whyTitle: "Pourquoi Nous Choisir",
    whySubtitle: "Notre engagement envers l'excellence et le professionnalisme",
    why1Title: "Expertise Spécialisée",
    why1Desc: "Équipe d'avocats avec une vaste expérience",
    why2Title: "Résultats Prouvés",
    why2Desc: "Historique de cas réussis",
    why3Title: "Approche Personnelle",
    why3Desc: "Solutions juridiques personnalisées pour chaque client",
    why4Title: "Toujours Disponible",
    why4Desc: "Soutien et suivi continus pour nos clients"
  },
  de: {
    home: "Startseite",
    about: "Über uns",
    services: "Dienstleistungen",
    team: "Team",
    testimonials: "Referenzen",
    contact: "Kontakt",
    heroTitle: "Juristische Exzellenz mit vertrauenswürdiger Expertise",
    heroSubtitle: "Professionelle Rechtsberatung und Vertretung in allen Rechtsbereichen",
    heroButton: "Beratung buchen",
    aboutTitle: "Über Rechtsanwältin Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Eine führende Anwaltskanzlei in den VAE, spezialisiert auf umfassende Rechtsdienstleistungen für Privatpersonen und Unternehmen. Wir sind stolz darauf, außergewöhnliche Rechtsberatung und professionelle Vertretung nach höchsten Standards zu bieten.",
    aboutYears: "Jahre Erfahrung",
    aboutCases: "Erfolgreiche Fälle",
    aboutClients: "Zufriedene Kunden",
    servicesTitle: "Unsere Rechtsdienstleistungen",
    servicesSubtitle: "Wir bieten eine umfassende Palette spezialisierter Rechtsdienstleistungen",
    service1Title: "Handelsrecht",
    service1Desc: "Umfassende Rechtsberatung für Unternehmen und Geschäfte",
    service2Title: "Zivilrecht",
    service2Desc: "Rechtsvertretung in Zivilsachen und Streitigkeiten",
    service3Title: "Familienrecht",
    service3Desc: "Sensible Rechtslösungen für Familien- und Personenstandsangelegenheiten",
    service4Title: "Immobilienrecht",
    service4Desc: "Umfassende Rechtsdienstleistungen bei Immobilientransaktionen",
    service5Title: "Strafrecht",
    service5Desc: "Starke und spezialisierte Verteidigung in Strafsachen",
    service6Title: "Arbeitsrecht",
    service6Desc: "Schutz der Rechte von Arbeitnehmern und Arbeitgebern",
    teamTitle: "Unser Rechtsteam",
    teamSubtitle: "Spezialisierte Anwälte und erfahrene Rechtsberater",
    teamRole: "Gründerin und Leitende Rechtsanwältin",
    teamBio: "Eine angesehene Anwältin mit umfangreicher Erfahrung in verschiedenen Rechtsbereichen, engagiert, den Mandanten die besten Rechtsdienstleistungen zu bieten",
    testimonialsTitle: "Kundenmeinungen",
    testimonialsSubtitle: "Das Vertrauen unserer Kunden ist unser größter Erfolg",
    testimonial1: "Außergewöhnlicher und hochprofessioneller Rechtsservice. Sie haben mir geholfen, meinen Fall effizient und professionell zu lösen",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Geschäftsmann",
    testimonial2: "Professionelles und freundliches Team. Ich empfehle ihre hervorragenden Rechtsdienstleistungen sehr",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Unternehmensdirektorin",
    testimonial3: "Exzellente rechtliche Expertise und hervorragende Ergebnisse. Vielen Dank für die kontinuierliche Unterstützung",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Investor",
    contactTitle: "Kontaktieren Sie uns",
    contactSubtitle: "Wir sind hier, um Sie bei Ihren rechtlichen Bedürfnissen zu unterstützen",
    contactName: "Vollständiger Name",
    contactEmail: "E-Mail-Adresse",
    contactPhone: "Telefonnummer",
    contactMessage: "Ihre Nachricht",
    contactButton: "Nachricht senden",
    contactSuccess: "Ihre Nachricht wurde erfolgreich gesendet! Wir werden uns bald bei Ihnen melden",
    footerAbout: "Über uns",
    footerAboutText: "Eine spezialisierte Anwaltskanzlei, die umfassende und herausragende Rechtsdienstleistungen in den VAE bietet",
    footerQuickLinks: "Schnelllinks",
    footerContact: "Kontaktinformationen",
    footerRights: "Alle Rechte vorbehalten",
    whyTitle: "Warum uns wählen",
    whySubtitle: "Unser Engagement für Exzellenz und Professionalität",
    why1Title: "Spezialisierte Expertise",
    why1Desc: "Team von Anwälten mit umfangreicher Erfahrung",
    why2Title: "Bewährte Ergebnisse",
    why2Desc: "Erfolgsbilanz erfolgreicher Fälle",
    why3Title: "Persönlicher Ansatz",
    why3Desc: "Maßgeschneiderte Rechtslösungen für jeden Mandanten",
    why4Title: "Immer verfügbar",
    why4Desc: "Kontinuierliche Unterstützung und Nachverfolgung für unsere Mandanten"
  },
  ja: {
    home: "ホーム",
    about: "私たちについて",
    services: "サービス",
    team: "チーム",
    testimonials: "お客様の声",
    contact: "お問い合わせ",
    heroTitle: "信頼できる専門知識による法的卓越性",
    heroSubtitle: "すべての法律分野における専門的な法律相談と代理",
    heroButton: "相談予約",
    aboutTitle: "弁護士ファティマ・アブドゥルクドゥス・アル・オベイドリについて",
    aboutDescription: "個人および企業向けの包括的な法律サービスを専門とするUAEの大手法律事務所。最高水準の卓越した法律相談と専門的な代理を提供することに誇りを持っています。",
    aboutYears: "年の経験",
    aboutCases: "成功事例",
    aboutClients: "満足したクライアント",
    servicesTitle: "法律サービス",
    servicesSubtitle: "専門的な法律サービスの包括的な範囲を提供します",
    service1Title: "商法",
    service1Desc: "企業および商業ビジネスのための包括的な法律相談",
    service2Title: "民法",
    service2Desc: "民事事件および紛争における法的代理",
    service3Title: "家族法",
    service3Desc: "家族および個人的地位の問題に対する慎重な法的解決策",
    service4Title: "不動産法",
    service4Desc: "不動産取引における包括的な法律サービス",
    service5Title: "刑法",
    service5Desc: "刑事事件における強力で専門的な弁護",
    service6Title: "労働法",
    service6Desc: "従業員と雇用主の権利保護",
    teamTitle: "法務チーム",
    teamSubtitle: "専門弁護士と経験豊富な法律コンサルタント",
    teamRole: "創設者兼主任弁護士",
    teamBio: "様々な法律分野で豊富な経験を持つ著名な弁護士で、クライアントに最高の法律サービスを提供することに尽力しています",
    testimonialsTitle: "お客様の声",
    testimonialsSubtitle: "お客様の信頼が私たちの最大の成果です",
    testimonial1: "卓越した高度に専門的な法律サービス。彼らは私の事件を効率的かつ専門的に解決するのを手伝ってくれました",
    testimonial1Name: "アハメド・アル・マンスーリ",
    testimonial1Role: "実業家",
    testimonial2: "プロフェッショナルでフレンドリーなチーム。彼らの優れた法律サービスを強くお勧めします",
    testimonial2Name: "サラ・アル・シャムシ",
    testimonial2Role: "会社取締役",
    testimonial3: "優れた法的専門知識と卓越した成果。継続的なサポートをありがとうございます",
    testimonial3Name: "モハメド・アル・カービ",
    testimonial3Role: "投資家",
    contactTitle: "お問い合わせ",
    contactSubtitle: "法的ニーズのお手伝いをいたします",
    contactName: "氏名",
    contactEmail: "メールアドレス",
    contactPhone: "電話番号",
    contactMessage: "メッセージ",
    contactButton: "送信",
    contactSuccess: "メッセージが正常に送信されました！すぐにご連絡いたします",
    footerAbout: "私たちについて",
    footerAboutText: "UAEで包括的で優れた法律サービスを提供する専門法律事務所",
    footerQuickLinks: "クイックリンク",
    footerContact: "お問い合わせ情報",
    footerRights: "すべての権利を保有",
    whyTitle: "選ばれる理由",
    whySubtitle: "卓越性とプロフェッショナリズムへの私たちのコミットメント",
    why1Title: "専門的な専門知識",
    why1Desc: "豊富な経験を持つ弁護士チーム",
    why2Title: "実証された成果",
    why2Desc: "成功事例の実績",
    why3Title: "個人的なアプローチ",
    why3Desc: "各クライアントのためのカスタマイズされた法的解決策",
    why4Title: "常に利用可能",
    why4Desc: "クライアントへの継続的なサポートとフォローアップ"
  },
  ko: {
    home: "홈",
    about: "소개",
    services: "서비스",
    team: "팀",
    testimonials: "고객 후기",
    contact: "연락처",
    heroTitle: "신뢰할 수 있는 전문성을 갖춘 법률 우수성",
    heroSubtitle: "모든 법률 분야에 걸친 전문적인 법률 상담 및 대리",
    heroButton: "상담 예약",
    aboutTitle: "변호사 파티마 압둘쿠두스 알 오베이들리 소개",
    aboutDescription: "개인 및 기업을 위한 포괄적인 법률 서비스를 전문으로 하는 UAE의 선도적인 법률 회사입니다. 최고 수준의 탁월한 법률 자문과 전문적인 대리를 제공하는 것을 자랑스럽게 생각합니다.",
    aboutYears: "년간의 경험",
    aboutCases: "성공 사례",
    aboutClients: "만족한 고객",
    servicesTitle: "법률 서비스",
    servicesSubtitle: "전문화된 법률 서비스의 포괄적인 범위를 제공합니다",
    service1Title: "상법",
    service1Desc: "기업 및 상업 비즈니스를 위한 포괄적인 법률 자문",
    service2Title: "민법",
    service2Desc: "민사 사건 및 분쟁에서의 법적 대리",
    service3Title: "가족법",
    service3Desc: "가족 및 개인 신분 문제에 대한 세심한 법적 해결책",
    service4Title: "부동산법",
    service4Desc: "부동산 거래에서의 포괄적인 법률 서비스",
    service5Title: "형법",
    service5Desc: "형사 사건에서의 강력하고 전문적인 변호",
    service6Title: "노동법",
    service6Desc: "직원 및 고용주 권리 보호",
    teamTitle: "법무팀",
    teamSubtitle: "전문 변호사 및 경험 많은 법률 컨설턴트",
    teamRole: "설립자 및 수석 변호사",
    teamBio: "다양한 법률 분야에서 폭넓은 경험을 가진 저명한 변호사로, 고객에게 최고의 법률 서비스를 제공하기 위해 헌신하고 있습니다",
    testimonialsTitle: "고객 후기",
    testimonialsSubtitle: "고객의 신뢰는 우리의 가장 큰 성과입니다",
    testimonial1: "탁월하고 매우 전문적인 법률 서비스. 그들은 제 사건을 효율적이고 전문적으로 해결하도록 도와주었습니다",
    testimonial1Name: "아메드 알 만수리",
    testimonial1Role: "사업가",
    testimonial2: "전문적이고 친절한 팀. 그들의 뛰어난 법률 서비스를 강력히 추천합니다",
    testimonial2Name: "사라 알 샴시",
    testimonial2Role: "회사 이사",
    testimonial3: "훌륭한 법률 전문 지식과 뛰어난 결과. 지속적인 지원에 감사드립니다",
    testimonial3Name: "모하메드 알 카비",
    testimonial3Role: "투자자",
    contactTitle: "연락하기",
    contactSubtitle: "법률 요구 사항을 도와드리겠습니다",
    contactName: "성명",
    contactEmail: "이메일 주소",
    contactPhone: "전화번호",
    contactMessage: "메시지",
    contactButton: "메시지 보내기",
    contactSuccess: "메시지가 성공적으로 전송되었습니다! 곧 연락드리겠습니다",
    footerAbout: "소개",
    footerAboutText: "UAE에서 포괄적이고 뛰어난 법률 서비스를 제공하는 전문 법률 회사",
    footerQuickLinks: "빠른 링크",
    footerContact: "연락처 정보",
    footerRights: "모든 권리 보유",
    whyTitle: "우리를 선택하는 이유",
    whySubtitle: "우수성과 전문성에 대한 우리의 약속",
    why1Title: "전문화된 전문 지식",
    why1Desc: "폭넓은 경험을 가진 변호사 팀",
    why2Title: "입증된 결과",
    why2Desc: "성공 사례의 실적",
    why3Title: "개인적인 접근",
    why3Desc: "각 고객을 위한 맞춤형 법률 솔루션",
    why4Title: "항상 이용 가능",
    why4Desc: "고객을 위한 지속적인 지원 및 후속 조치"
  },
  sw: {
    home: "Nyumbani",
    about: "Kuhusu",
    services: "Huduma",
    team: "Timu",
    testimonials: "Ushuhuda",
    contact: "Wasiliana",
    heroTitle: "Ubora wa Kisheria na Utaalamu wa Kuaminika",
    heroSubtitle: "Ushauri wa kisheria wa kitaalamu na uwakilishi katika maeneo yote ya sheria",
    heroButton: "Weka Miadi ya Ushauri",
    aboutTitle: "Kuhusu Mwanasheria Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Kampuni ya kisheria inayoongoza UAE inayofanya kazi katika huduma kamili za kisheria kwa watu binafsi na biashara. Tunajivunia kutoa ushauri wa kisheria wa kipekee na uwakilishi wa kitaalamu kwa viwango vya juu zaidi.",
    aboutYears: "Miaka ya Uzoefu",
    aboutCases: "Kesi Zilizofanikiwa",
    aboutClients: "Wateja Wenye Kuridhika",
    servicesTitle: "Huduma Zetu za Kisheria",
    servicesSubtitle: "Tunatoa safu kamili ya huduma za kisheria za kitaalamu",
    service1Title: "Sheria ya Biashara",
    service1Desc: "Ushauri kamili wa kisheria kwa makampuni na biashara za kibiashara",
    service2Title: "Sheria ya Kiraia",
    service2Desc: "Uwakilishi wa kisheria katika kesi za kiraia na migogoro",
    service3Title: "Sheria ya Familia",
    service3Desc: "Suluhisho za kisheria zenye hisia kwa familia na masuala ya hali ya kibinafsi",
    service4Title: "Sheria ya Mali Isiyohamishika",
    service4Desc: "Huduma kamili za kisheria katika miamala ya mali isiyohamishika",
    service5Title: "Sheria ya Jinai",
    service5Desc: "Utetezi imara na wa kitaalamu katika kesi za jinai",
    service6Title: "Sheria ya Kazi",
    service6Desc: "Ulinzi wa haki za wafanyakazi na waajiri",
    teamTitle: "Timu Yetu ya Kisheria",
    teamSubtitle: "Mawakili wa kitaalamu na washauri wa kisheria wenye uzoefu",
    teamRole: "Mwanzilishi na Mwanasheria Mkuu",
    teamBio: "Mwanasheria mzuri mwenye uzoefu mkubwa katika nyanja mbalimbali za kisheria, aliyejitolea kutoa huduma bora za kisheria kwa wateja",
    testimonialsTitle: "Ushuhuda wa Wateja",
    testimonialsSubtitle: "Imani ya wateja wetu ni mafanikio yetu makuu",
    testimonial1: "Huduma ya kisheria ya kipekee na ya kitaalamu sana. Walinisaidia kutatua kesi yangu kwa ufanisi na kitaalamu",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Mfanyabiashara",
    testimonial2: "Timu ya kitaalamu na ya kirafiki. Napendekeza sana huduma zao bora za kisheria",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Mkurugenzi wa Kampuni",
    testimonial3: "Utaalamu bora wa kisheria na matokeo mazuri. Asante kwa msaada wa kuendelea",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Mwekezaji",
    contactTitle: "Wasiliana Nasi",
    contactSubtitle: "Tuko hapa kusaidia na mahitaji yako ya kisheria",
    contactName: "Jina Kamili",
    contactEmail: "Anwani ya Barua Pepe",
    contactPhone: "Nambari ya Simu",
    contactMessage: "Ujumbe Wako",
    contactButton: "Tuma Ujumbe",
    contactSuccess: "Ujumbe wako umetumwa kwa mafanikio! Tutawasiliana nawe hivi karibuni",
    footerAbout: "Kuhusu Sisi",
    footerAboutText: "Kampuni ya kisheria ya kitaalamu inayotoa huduma kamili na za kipekee za kisheria UAE",
    footerQuickLinks: "Viungo vya Haraka",
    footerContact: "Maelezo ya Mawasiliano",
    footerRights: "Haki Zote Zimehifadhiwa",
    whyTitle: "Kwa Nini Utuchague",
    whySubtitle: "Kujitolea kwetu kwa ubora na utaalamu",
    why1Title: "Utaalamu wa Kitaalamu",
    why1Desc: "Timu ya mawakili wenye uzoefu mkubwa",
    why2Title: "Matokeo Yaliyothibitishwa",
    why2Desc: "Rekodi ya kesi zilizofanikiwa",
    why3Title: "Mbinu ya Kibinafsi",
    why3Desc: "Suluhisho za kisheria zilizobinafsishwa kwa kila mteja",
    why4Title: "Daima Inapatikana",
    why4Desc: "Msaada na ufuatiliaji wa kuendelea kwa wateja wetu"
  },
  af: {
    home: "Tuis",
    about: "Oor Ons",
    services: "Dienste",
    team: "Span",
    testimonials: "Getuigskrifte",
    contact: "Kontak",
    heroTitle: "Regkundige Uitnemendheid met Betroubare Kundigheid",
    heroSubtitle: "Professionele regskonsultasie en verteenwoordiging in alle areas van die reg",
    heroButton: "Bespreek Konsultasie",
    aboutTitle: "Oor Advokaat Fatima Abdulqudous Al Obeidli",
    aboutDescription: "ʼn Toonaangewende regsfirma in die VAE wat spesialiseer in omvattende regsdienste vir individue en besighede. Ons is trots daarop om uitsonderlike regskonsultasie en professionele verteenwoordiging volgens die hoogste standaarde te lewer.",
    aboutYears: "Jare Ondervinding",
    aboutCases: "Suksesvolle Sake",
    aboutClients: "Tevrede Kliënte",
    servicesTitle: "Ons Regsdienste",
    servicesSubtitle: "Ons bied ʼn omvattende reeks gespesialiseerde regsdienste",
    service1Title: "Handelsreg",
    service1Desc: "Omvattende regskonsultasie vir maatskappye en kommersiële besighede",
    service2Title: "Siviele Reg",
    service2Desc: "Regsverteenwoordiging in siviele sake en dispute",
    service3Title: "Familiereg",
    service3Desc: "Sensitiewe regsoplossings vir familie- en persoonlike statusaangeleenthede",
    service4Title: "Eiendomsreg",
    service4Desc: "Omvattende regsdienste in eiendomstransaksies",
    service5Title: "Strafreg",
    service5Desc: "Sterk en gespesialiseerde verdediging in strafsake",
    service6Title: "Arbeidsreg",
    service6Desc: "Beskerming van werknemers- en werkgewersregte",
    teamTitle: "Ons Regspan",
    teamSubtitle: "Gespesialiseerde prokureurs en ervare regskonsultante",
    teamRole: "Stigter en Hoofadvokaat",
    teamBio: "ʼn Gerespekteerde advokaat met uitgebreide ondervinding in verskeie regsareas, toegewy tot die verskaffing van die beste regsdienste aan kliënte",
    testimonialsTitle: "Kliëntgetuigskrifte",
    testimonialsSubtitle: "Ons kliënte se vertroue is ons grootste prestasie",
    testimonial1: "Uitsonderlike en hoogs professionele regsdiens. Hulle het my gehelp om my saak doeltreffend en professioneel op te los",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Sakeman",
    testimonial2: "Professionele en vriendelike span. Beveel hulle uitstaande regsdienste sterk aan",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Maatskappydirekteur",
    testimonial3: "Uitstekende regskundigheid en uitstaande resultate. Dankie vir die voortdurende ondersteuning",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Belegger",
    contactTitle: "Kontak Ons",
    contactSubtitle: "Ons is hier om te help met u regsbehoeftes",
    contactName: "Volledige Naam",
    contactEmail: "E-posadres",
    contactPhone: "Telefoonnommer",
    contactMessage: "U Boodskap",
    contactButton: "Stuur Boodskap",
    contactSuccess: "U boodskap is suksesvol gestuur! Ons sal binnekort met u kontak maak",
    footerAbout: "Oor Ons",
    footerAboutText: "ʼn Gespesialiseerde regsfirma wat omvattende en onderskeidende regsdienste in die VAE verskaf",
    footerQuickLinks: "Vinnige Skakels",
    footerContact: "Kontakinligting",
    footerRights: "Alle Regte Voorbehou",
    whyTitle: "Hoekom Ons Kies",
    whySubtitle: "Ons verbintenis tot uitnemendheid en professionaliteit",
    why1Title: "Gespesialiseerde Kundigheid",
    why1Desc: "Span prokureurs met uitgebreide ondervinding",
    why2Title: "Bewese Resultate",
    why2Desc: "Rekord van suksesvolle sake",
    why3Title: "Persoonlike Benadering",
    why3Desc: "Aangepaste regsoplossings vir elke kliënt",
    why4Title: "Altyd Beskikbaar",
    why4Desc: "Voortdurende ondersteuning en opvolg vir ons kliënte"
  },
  ur: {
    home: "ہوم",
    about: "ہمارے بارے میں",
    services: "خدمات",
    team: "ٹیم",
    testimonials: "تعریفیں",
    contact: "رابطہ",
    heroTitle: "قابل اعتماد مہارت کے ساتھ قانونی فضیلت",
    heroSubtitle: "قانون کے تمام شعبوں میں پیشہ ورانہ قانونی مشاورت اور نمائندگی",
    heroButton: "مشاورت بک کریں",
    aboutTitle: "وکیل فاطمہ عبدالقدوس العبیدلی کے بارے میں",
    aboutDescription: "متحدہ عرب امارات میں ایک معروف قانونی فرم جو افراد اور کاروباروں کے لیے جامع قانونی خدمات میں مہارت رکھتی ہے۔ ہمیں اعلیٰ ترین معیار کے مطابق غیر معمولی قانونی مشاورت اور پیشہ ورانہ نمائندگی فراہم کرنے پر فخر ہے۔",
    aboutYears: "سال کا تجربہ",
    aboutCases: "کامیاب کیسز",
    aboutClients: "مطمئن کلائنٹس",
    servicesTitle: "ہماری قانونی خدمات",
    servicesSubtitle: "ہم خصوصی قانونی خدمات کی ایک جامع رینج پیش کرتے ہیں",
    service1Title: "تجارتی قانون",
    service1Desc: "کمپنیوں اور تجارتی کاروباروں کے لیے جامع قانونی مشاورت",
    service2Title: "سول قانون",
    service2Desc: "سول مقدمات اور تنازعات میں قانونی نمائندگی",
    service3Title: "خاندانی قانون",
    service3Desc: "خاندانی اور ذاتی حیثیت کے معاملات کے لیے حساس قانونی حل",
    service4Title: "رئیل اسٹیٹ قانون",
    service4Desc: "رئیل اسٹیٹ لین دین میں جامع قانونی خدمات",
    service5Title: "فوجداری قانون",
    service5Desc: "فوجداری مقدمات میں مضبوط اور خصوصی دفاع",
    service6Title: "لیبر قانون",
    service6Desc: "ملازمین اور آجروں کے حقوق کا تحفظ",
    teamTitle: "ہماری قانونی ٹیم",
    teamSubtitle: "ماہر وکلاء اور تجربہ کار قانونی مشیر",
    teamRole: "بانی اور سربراہ وکیل",
    teamBio: "مختلف قانونی شعبوں میں وسیع تجربہ رکھنے والے ایک ممتاز وکیل، کلائنٹس کو بہترین قانونی خدمات فراہم کرنے کے لیے پرعزم",
    testimonialsTitle: "کلائنٹس کی رائے",
    testimonialsSubtitle: "ہمارے کلائنٹس کا اعتماد ہماری سب سے بڑی کامیابی ہے",
    testimonial1: "غیر معمولی اور انتہائی پیشہ ورانہ قانونی خدمت۔ انہوں نے میرے کیس کو مؤثر اور پیشہ ورانہ انداز میں حل کرنے میں میری مدد کی",
    testimonial1Name: "احمد المنصوری",
    testimonial1Role: "کاروباری",
    testimonial2: "پیشہ ور اور دوستانہ ٹیم۔ ان کی بہترین قانونی خدمات کی بھرپور سفارش کرتا ہوں",
    testimonial2Name: "سارہ الشامسی",
    testimonial2Role: "کمپنی ڈائریکٹر",
    testimonial3: "بہترین قانونی مہارت اور شاندار نتائج۔ مسلسل تعاون کے لیے شکریہ",
    testimonial3Name: "محمد الکعبی",
    testimonial3Role: "سرمایہ کار",
    contactTitle: "ہم سے رابطہ کریں",
    contactSubtitle: "ہم آپ کی قانونی ضروریات میں مدد کے لیے یہاں موجود ہیں",
    contactName: "مکمل نام",
    contactEmail: "ای میل ایڈریس",
    contactPhone: "فون نمبر",
    contactMessage: "آپ کا پیغام",
    contactButton: "پیغام بھیجیں",
    contactSuccess: "آپ کا پیغام کامیابی سے بھیج دیا گیا ہے! ہم جلد ہی آپ سے رابطہ کریں گے",
    footerAbout: "ہمارے بارے میں",
    footerAboutText: "متحدہ عرب امارات میں جامع اور ممتاز قانونی خدمات فراہم کرنے والی ایک خصوصی قانونی فرم",
    footerQuickLinks: "فوری لنکس",
    footerContact: "رابطے کی معلومات",
    footerRights: "تمام حقوق محفوظ ہیں",
    whyTitle: "ہمیں کیوں منتخب کریں",
    whySubtitle: "فضیلت اور پیشہ ورانہ مہارت کے لیے ہماری وابستگی",
    why1Title: "خصوصی مہارت",
    why1Desc: "وسیع تجربہ رکھنے والے وکلاء کی ٹیم",
    why2Title: "ثابت شدہ نتائج",
    why2Desc: "کامیاب مقدمات کا ریکارڈ",
    why3Title: "ذاتی نقطہ نظر",
    why3Desc: "ہر کلائنٹ کے لیے حسب ضرورت قانونی حل",
    why4Title: "ہمیشہ دستیاب",
    why4Desc: "ہمارے کلائنٹس کے لیے مسلسل تعاون اور پیروی"
  },
  bn: {
    home: "হোম",
    about: "আমাদের সম্পর্কে",
    services: "সেবা",
    team: "দল",
    testimonials: "প্রশংসাপত্র",
    contact: "যোগাযোগ",
    heroTitle: "বিশ্বস্ত দক্ষতার সাথে আইনি উৎকর্ষতা",
    heroSubtitle: "আইনের সকল ক্ষেত্রে পেশাদার আইনি পরামর্শ এবং প্রতিনিধিত্ব",
    heroButton: "পরামর্শ বুক করুন",
    aboutTitle: "অ্যাডভোকেট ফাতিমা আবদুলকুদুস আল ওবেইদলি সম্পর্কে",
    aboutDescription: "ইউএই-তে একটি শীর্ষস্থানীয় আইন সংস্থা যা ব্যক্তি এবং ব্যবসার জন্য ব্যাপক আইনি সেবায় বিশেষজ্ঞ। আমরা সর্বোচ্চ মানের ব্যতিক্রমী আইনি পরামর্শ এবং পেশাদার প্রতিনিধিত্ব প্রদান করতে গর্বিত।",
    aboutYears: "বছরের অভিজ্ঞতা",
    aboutCases: "সফল মামলা",
    aboutClients: "সন্তুষ্ট ক্লায়েন্ট",
    servicesTitle: "আমাদের আইনি সেবা",
    servicesSubtitle: "আমরা বিশেষায়িত আইনি সেবার একটি ব্যাপক পরিসীমা অফার করি",
    service1Title: "বাণিজ্যিক আইন",
    service1Desc: "কোম্পানি এবং বাণিজ্যিক ব্যবসার জন্য ব্যাপক আইনি পরামর্শ",
    service2Title: "সিভিল আইন",
    service2Desc: "সিভিল মামলা এবং বিরোধে আইনি প্রতিনিধিত্ব",
    service3Title: "পারিবারিক আইন",
    service3Desc: "পারিবারিক এবং ব্যক্তিগত অবস্থার বিষয়ে সংবেদনশীল আইনি সমাধান",
    service4Title: "রিয়েল এস্টেট আইন",
    service4Desc: "রিয়েল এস্টেট লেনদেনে ব্যাপক আইনি সেবা",
    service5Title: "ফৌজদারি আইন",
    service5Desc: "ফৌজদারি মামলায় শক্তিশালী এবং বিশেষায়িত প্রতিরক্ষা",
    service6Title: "শ্রম আইন",
    service6Desc: "কর্মচারী এবং নিয়োগকর্তা অধিকার সুরক্ষা",
    teamTitle: "আমাদের আইনি দল",
    teamSubtitle: "বিশেষায়িত আইনজীবী এবং অভিজ্ঞ আইনি পরামর্শদাতা",
    teamRole: "প্রতিষ্ঠাতা এবং প্রধান অ্যাডভোকেট",
    teamBio: "বিভিন্ন আইনি ক্ষেত্রে ব্যাপক অভিজ্ঞতা সম্পন্ন একজন বিশিষ্ট আইনজীবী, ক্লায়েন্টদের সেরা আইনি সেবা প্রদানে প্রতিশ্রুতিবদ্ধ",
    testimonialsTitle: "ক্লায়েন্ট প্রশংসাপত্র",
    testimonialsSubtitle: "আমাদের ক্লায়েন্টদের বিশ্বাস আমাদের সবচেয়ে বড় অর্জন",
    testimonial1: "ব্যতিক্রমী এবং অত্যন্ত পেশাদার আইনি সেবা। তারা আমাকে দক্ষতার সাথে এবং পেশাদারভাবে আমার মামলা সমাধান করতে সাহায্য করেছে",
    testimonial1Name: "আহমেদ আল মানসুরি",
    testimonial1Role: "ব্যবসায়ী",
    testimonial2: "পেশাদার এবং বন্ধুত্বপূর্ণ দল। তাদের অসাধারণ আইনি সেবার অত্যন্ত সুপারিশ করছি",
    testimonial2Name: "সারাহ আল শামসি",
    testimonial2Role: "কোম্পানি পরিচালক",
    testimonial3: "চমৎকার আইনি দক্ষতা এবং অসাধারণ ফলাফল। অবিরাম সমর্থনের জন্য ধন্যবাদ",
    testimonial3Name: "মোহাম্মদ আল কাবি",
    testimonial3Role: "বিনিয়োগকারী",
    contactTitle: "আমাদের সাথে যোগাযোগ করুন",
    contactSubtitle: "আপনার আইনি প্রয়োজনে সাহায্য করতে আমরা এখানে আছি",
    contactName: "পূর্ণ নাম",
    contactEmail: "ইমেইল ঠিকানা",
    contactPhone: "ফোন নম্বর",
    contactMessage: "আপনার বার্তা",
    contactButton: "বার্তা পাঠান",
    contactSuccess: "আপনার বার্তা সফলভাবে পাঠানো হয়েছে! আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব",
    footerAbout: "আমাদের সম্পর্কে",
    footerAboutText: "ইউএই-তে ব্যাপক এবং বিশিষ্ট আইনি সেবা প্রদানকারী একটি বিশেষায়িত আইন সংস্থা",
    footerQuickLinks: "দ্রুত লিঙ্ক",
    footerContact: "যোগাযোগের তথ্য",
    footerRights: "সকল অধিকার সংরক্ষিত",
    whyTitle: "কেন আমাদের নির্বাচন করবেন",
    whySubtitle: "উৎকর্ষতা এবং পেশাদারিত্বের প্রতি আমাদের অঙ্গীকার",
    why1Title: "বিশেষায়িত দক্ষতা",
    why1Desc: "ব্যাপক অভিজ্ঞতা সম্পন্ন আইনজীবীদের দল",
    why2Title: "প্রমাণিত ফলাফল",
    why2Desc: "সফল মামলার রেকর্ড",
    why3Title: "ব্যক্তিগত পদ্ধতি",
    why3Desc: "প্রতিটি ক্লায়েন্টের জন্য কাস্টমাইজড আইনি সমাধান",
    why4Title: "সর্বদা উপলব্ধ",
    why4Desc: "আমাদের ক্লায়েন্টদের জন্য অবিরাম সমর্থন এবং ফলো-আপ"
  },
  ml: {
    home: "ഹോം",
    about: "ഞങ്ങളെക്കുറിച്ച്",
    services: "സേവനങ്ങൾ",
    team: "ടീം",
    testimonials: "സാക്ഷ്യപത്രങ്ങൾ",
    contact: "ബന്ധപ്പെടുക",
    heroTitle: "വിശ്വസനീയമായ വൈദഗ്ധ്യത്തോടുകൂടിയ നിയമപരമായ മികവ്",
    heroSubtitle: "നിയമത്തിന്റെ എല്ലാ മേഖലകളിലും പ്രൊഫഷണൽ നിയമ കൺസൽറ്റേഷനും പ്രാതിനിധ്യവും",
    heroButton: "കൺസൾട്ടേഷൻ ബുക്ക് ചെയ്യുക",
    aboutTitle: "അഭിഭാഷക ഫാത്തിമ അബ്ദുൽഖുദൂസ് അൽ ഒബൈദ്‌ലിയെക്കുറിച്ച്",
    aboutDescription: "വ്യക്തികൾക്കും ബിസിനസ്സുകൾക്കും സമഗ്ര നിയമസേവനങ്ങളിൽ വൈദഗ്ദ്ധ്യം നേടിയ യു.എ.ഇയിലെ പ്രമുഖ നിയമ സ്ഥാപനം. ഉയർന്ന നിലവാരത്തിലുള്ള അസാധാരണമായ നിയമ കൺസൾട്ടേഷനും പ്രൊഫഷണൽ പ്രാതിനിധ്യവും നൽകുന്നതിൽ ഞങ്ങൾ അഭിമാനിക്കുന്നു.",
    aboutYears: "വർഷത്തെ പരിചയം",
    aboutCases: "വിജയകരമായ കേസുകൾ",
    aboutClients: "സംതൃപ്തരായ ക്ലയന്റുകൾ",
    servicesTitle: "ഞങ്ങളുടെ നിയമ സേവനങ്ങൾ",
    servicesSubtitle: "ഞങ്ങൾ സ്പെഷ്യലൈസ്ഡ് നിയമ സേവനങ്ങളുടെ സമഗ്ര ശ്രേണി വാഗ്ദാനം ചെയ്യുന്നു",
    service1Title: "വാണിജ്യ നിയമം",
    service1Desc: "കമ്പനികൾക്കും വാണിജ്യ ബിസിനസ്സുകൾക്കും സമഗ്ര നിയമ കൺസൾട്ടേഷൻ",
    service2Title: "സിവിൽ നിയമം",
    service2Desc: "സിവിൽ കേസുകളിലും തർക്കങ്ങളിലും നിയമ പ്രാതിനിധ്യം",
    service3Title: "കുടുംബ നിയമം",
    service3Desc: "കുടുംബ, വ്യക്തിഗത പദവി കാര്യങ്ങൾക്ക് സെൻസിറ്റീവ് നിയമ പരിഹാരങ്ങൾ",
    service4Title: "റിയൽ എസ്റ്റേറ്റ് നിയമം",
    service4Desc: "റിയൽ എസ്റ്റേറ്റ് ഇടപാടുകളിൽ സമഗ്ര നിയമ സേവനങ്ങൾ",
    service5Title: "ക്രിമിനൽ നിയമം",
    service5Desc: "ക്രിമിനൽ കേസുകളിൽ ശക്തവും സ്പെഷ്യലൈസ്ഡുമായ പ്രതിരോധം",
    service6Title: "തൊഴിൽ നിയമം",
    service6Desc: "ജീവനക്കാരുടെയും തൊഴിലുടമകളുടെയും അവകാശ സംരക്ഷണം",
    teamTitle: "ഞങ്ങളുടെ നിയമ ടീം",
    teamSubtitle: "സ്പെഷ്യലൈസ്ഡ് അഭിഭാഷകരും പരിചയസമ്പന്നരായ നിയമ കൺസൾട്ടന്റുമാരും",
    teamRole: "സ്ഥാപകനും പ്രധാന അഭിഭാഷകയും",
    teamBio: "വിവിധ നിയമ മേഖലകളിൽ വിപുലമായ പരിചയമുള്ള വിശിഷ്ട അഭിഭാഷക, ക്ലയന്റുകൾക്ക് മികച്ച നിയമ സേവനങ്ങൾ നൽകുന്നതിന് പ്രതിജ്ഞാബദ്ധ",
    testimonialsTitle: "ക്ലയന്റ് സാക്ഷ്യപത്രങ്ങൾ",
    testimonialsSubtitle: "ഞങ്ങളുടെ ക്ലയന്റുകളുടെ വിശ്വാസമാണ് ഞങ്ങളുടെ ഏറ്റവും വലിയ നേട്ടം",
    testimonial1: "അസാധാരണവും ഉയർന്ന പ്രൊഫഷണലുമായ നിയമ സേവനം. എന്റെ കേസ് കാര്യക്ഷമമായും പ്രൊഫഷണലായും പരിഹരിക്കാൻ അവർ എന്നെ സഹായിച്ചു",
    testimonial1Name: "അഹമ്മദ് അൽ മൻസൂരി",
    testimonial1Role: "ബിസിനസ്സുകാരൻ",
    testimonial2: "പ്രൊഫഷണലും സൗഹൃദപരവുമായ ടീം. അവരുടെ മികച്ച നിയമ സേവനങ്ങൾ ശക്തമായി ശുപാർശ ചെയ്യുന്നു",
    testimonial2Name: "സാറ അൽ ഷംസി",
    testimonial2Role: "കമ്പനി ഡയറക്ടർ",
    testimonial3: "മികച്ച നിയമ വൈദഗ്ദ്ധ്യവും മികച്ച ഫലങ്ങളും. തുടർച്ചയായ പിന്തുണയ്ക്ക് നന്ദി",
    testimonial3Name: "മുഹമ്മദ് അൽ കാബി",
    testimonial3Role: "നിക്ഷേപകൻ",
    contactTitle: "ഞങ്ങളെ ബന്ധപ്പെടുക",
    contactSubtitle: "നിങ്ങളുടെ നിയമ ആവശ്യങ്ങളിൽ സഹായിക്കാൻ ഞങ്ങൾ ഇവിടെയുണ്ട്",
    contactName: "പൂർണ്ണ നാമം",
    contactEmail: "ഇമെയിൽ വിലാസം",
    contactPhone: "ഫോൺ നമ്പർ",
    contactMessage: "നിങ്ങളുടെ സന്ദേശം",
    contactButton: "സന്ദേശം അയയ്ക്കുക",
    contactSuccess: "നിങ്ങളുടെ സന്ദേശം വിജയകരമായി അയച്ചു! ഞങ്ങൾ ഉടൻ നിങ്ങളെ ബന്ധപ്പെടും",
    footerAbout: "ഞങ്ങളെക്കുറിച്ച്",
    footerAboutText: "യു.എ.ഇയിൽ സമഗ്രവും മികച്ചതുമായ നിയമ സേവനങ്ങൾ നൽകുന്ന ഒരു സ്പെഷ്യലൈസ്ഡ് നിയമ സ്ഥാപനം",
    footerQuickLinks: "ദ്രുത ലിങ്കുകൾ",
    footerContact: "ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ",
    footerRights: "എല്ലാ അവകാശങ്ങളും സംരക്ഷിതം",
    whyTitle: "എന്തുകൊണ്ട് ഞങ്ങളെ തിരഞ്ഞെടുക്കണം",
    whySubtitle: "മികവിനും പ്രൊഫഷണലിസത്തിനുമുള്ള ഞങ്ങളുടെ പ്രതിജ്ഞാബദ്ധത",
    why1Title: "സ്പെഷ്യലൈസ്ഡ് വൈദഗ്ദ്ധ്യം",
    why1Desc: "വിപുലമായ പരിചയമുള്ള അഭിഭാഷകരുടെ ടീം",
    why2Title: "തെളിയിക്കപ്പെട്ട ഫലങ്ങൾ",
    why2Desc: "വിജയകരമായ കേസുകളുടെ റെക്കോർഡ്",
    why3Title: "വ്യക്തിഗത സമീപനം",
    why3Desc: "ഓരോ ക്ലയന്റിനും കസ്റ്റമൈസ്ഡ് നിയമ പരിഹാരങ്ങൾ",
    why4Title: "എപ്പോഴും ലഭ്യമാണ്",
    why4Desc: "ഞങ്ങളുടെ ക്ലയന്റുകൾക്ക് തുടർച്ചയായ പിന്തുണയും ഫോളോ-അപ്പും"
  },
  ta: {
    home: "முகப்பு",
    about: "எங்களைப் பற்றி",
    services: "சேவைகள்",
    team: "குழு",
    testimonials: "சான்றுகள்",
    contact: "தொடர்பு",
    heroTitle: "நம்பகமான நிபுணத்துவத்துடன் சட்ட சிறப்பு",
    heroSubtitle: "சட்டத்தின் அனைத்து துறைகளிலும் தொழில்முறை சட்ட ஆலோசனை மற்றும் பிரதிநிதித்துவம்",
    heroButton: "ஆலோசனை பதிவு செய்யுங்கள்",
    aboutTitle: "வழக்கறிஞர் ஃபாத்திமா அப்துல்குதூஸ் அல் ஒபைத்லி பற்றி",
    aboutDescription: "தனிநபர்கள் மற்றும் வணிகங்களுக்கான விரிவான சட்ட சேவைகளில் நிபுணத்துவம் பெற்ற UAE இல் முன்னணி சட்ட நிறுவனம். உயர்ந்த தரத்தில் விதிவிலக்கான சட்ட ஆலோசனை மற்றும் தொழில்முறை பிரதிநிதித்துவம் வழங்குவதில் நாங்கள் பெருமிதம் கொள்கிறோம்.",
    aboutYears: "ஆண்டுகள் அனுபவம்",
    aboutCases: "வெற்றிகரமான வழக்குகள்",
    aboutClients: "திருப்தியான வாடிக்கையாளர்கள்",
    servicesTitle: "எங்கள் சட்ட சேவைகள்",
    servicesSubtitle: "நாங்கள் சிறப்பு சட்ட சேவைகளின் விரிவான வரம்பை வழங்குகிறோம்",
    service1Title: "வணிக சட்டம்",
    service1Desc: "நிறுவனங்கள் மற்றும் வணிக வணிகங்களுக்கான விரிவான சட்ட ஆலோசனை",
    service2Title: "சிவில் சட்டம்",
    service2Desc: "சிவில் வழக்குகள் மற்றும் சர்ச்சைகளில் சட்ட பிரதிநிதித்துவம்",
    service3Title: "குடும்ப சட்டம்",
    service3Desc: "குடும்பம் மற்றும் தனிப்பட்ட நிலை விஷயங்களுக்கான உணர்திறன் சட்ட தீர்வுகள்",
    service4Title: "ரியல் எஸ்டேட் சட்டம்",
    service4Desc: "ரியல் எஸ்டேட் பரிவர்த்தனைகளில் விரிவான சட்ட சேவைகள்",
    service5Title: "குற்றவியல் சட்டம்",
    service5Desc: "குற்றவியல் வழக்குகளில் வலுவான மற்றும் சிறப்பு பாதுகாப்பு",
    service6Title: "தொழிலாளர் சட்டம்",
    service6Desc: "பணியாளர் மற்றும் முதலாளி உரிமைகள் பாதுகாப்பு",
    teamTitle: "எங்கள் சட்ட குழு",
    teamSubtitle: "சிறப்பு வழக்கறிஞர்கள் மற்றும் அனுபவம் வாய்ந்த சட்ட ஆலோசகர்கள்",
    teamRole: "நிறுவனர் மற்றும் முதன்மை வழக்கறிஞர்",
    teamBio: "பல்வேறு சட்ட துறைகளில் விரிவான அனுபவம் கொண்ட ஒரு புகழ்பெற்ற வழக்கறிஞர், வாடிக்கையாளர்களுக்கு சிறந்த சட்ட சேவைகளை வழங்குவதில் அர்ப்பணிப்புடன்",
    testimonialsTitle: "வாடிக்கையாளர் சான்றுகள்",
    testimonialsSubtitle: "எங்கள் வாடிக்கையாளர்களின் நம்பிக்கை எங்கள் மிகப்பெரிய சாதனை",
    testimonial1: "விதிவிலக்கான மற்றும் மிகவும் தொழில்முறை சட்ட சேவை. அவர்கள் என் வழக்கை திறமையாகவும் தொழில்முறையாகவும் தீர்க்க எனக்கு உதவினார்கள்",
    testimonial1Name: "அகமது அல் மன்சூரி",
    testimonial1Role: "வணிகர்",
    testimonial2: "தொழில்முறை மற்றும் நட்புரீதியான குழு. அவர்களின் சிறந்த சட்ட சேவைகளை மிகவும் பரிந்துரைக்கிறேன்",
    testimonial2Name: "சாரா அல் ஷம்சி",
    testimonial2Role: "நிறுவன இயக்குனர்",
    testimonial3: "சிறந்த சட்ட நிபுணத்துவம் மற்றும் சிறந்த முடிவுகள். தொடர்ந்த ஆதரவுக்கு நன்றி",
    testimonial3Name: "முகமது அல் காபி",
    testimonial3Role: "முதலீட்டாளர்",
    contactTitle: "எங்களை தொடர்பு கொள்ளுங்கள்",
    contactSubtitle: "உங்கள் சட்ட தேவைகளுக்கு உதவ நாங்கள் இங்கே இருக்கிறோம்",
    contactName: "முழு பெயர்",
    contactEmail: "மின்னஞ்சல் முகவரி",
    contactPhone: "தொலைபேசி எண்",
    contactMessage: "உங்கள் செய்தி",
    contactButton: "செய்தியை அனுப்பு",
    contactSuccess: "உங்கள் செய்தி வெற்றிகரமாக அனுப்பப்பட்டது! நாங்கள் விரைவில் உங்களை தொடர்பு கொள்வோம்",
    footerAbout: "எங்களைப் பற்றி",
    footerAboutText: "UAE இல் விரிவான மற்றும் சிறப்பு சட்ட சேவைகளை வழங்கும் ஒரு சிறப்பு சட்ட நிறுவனம்",
    footerQuickLinks: "விரைவு இணைப்புகள்",
    footerContact: "தொடர்பு தகவல்",
    footerRights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை",
    whyTitle: "ஏன் எங்களை தேர்வு செய்ய வேண்டும்",
    whySubtitle: "சிறப்பு மற்றும் தொழில்முறைக்கான எங்கள் அர்ப்பணிப்பு",
    why1Title: "சிறப்பு நிபுணத்துவம்",
    why1Desc: "விரிவான அனுபவம் கொண்ட வழக்கறிஞர்கள் குழு",
    why2Title: "நிரூபிக்கப்பட்ட முடிவுகள்",
    why2Desc: "வெற்றிகரமான வழக்குகளின் பதிவு",
    why3Title: "தனிப்பட்ட அணுகுமுறை",
    why3Desc: "ஒவ்வொரு வாடிக்கையாளருக்கும் தனிப்பயனாக்கப்பட்ட சட்ட தீர்வுகள்",
    why4Title: "எப்போதும் கிடைக்கும்",
    why4Desc: "எங்கள் வாடிக்கையாளர்களுக்கு தொடர்ச்சியான ஆதரவு மற்றும் தொடர்"
  },
  tl: {
    home: "Home",
    about: "Tungkol",
    services: "Serbisyo",
    team: "Koponan",
    testimonials: "Testimonya",
    contact: "Makipag-ugnayan",
    heroTitle: "Kahusayan sa Legal na may Pinagkakatiwalaang Kadalubhasaan",
    heroSubtitle: "Propesyonal na legal na konsultasyon at representasyon sa lahat ng larangan ng batas",
    heroButton: "Mag-book ng Konsultasyon",
    aboutTitle: "Tungkol kay Abogado Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Isang nangungunang law firm sa UAE na dalubhasa sa komprehensibong legal na serbisyo para sa mga indibidwal at negosyo. Ipinagmamalaki namin ang pagbibigay ng pambihirang legal na konsultasyon at propesyonal na representasyon sa pinakamataas na pamantayan.",
    aboutYears: "Taon ng Karanasan",
    aboutCases: "Matagumpay na Kaso",
    aboutClients: "Nasiyahang Kliyente",
    servicesTitle: "Aming Legal na Serbisyo",
    servicesSubtitle: "Nag-aalok kami ng komprehensibong hanay ng espesyalisadong legal na serbisyo",
    service1Title: "Batas Pangkalakal",
    service1Desc: "Komprehensibong legal na konsultasyon para sa mga kumpanya at komersyal na negosyo",
    service2Title: "Batas Sibil",
    service2Desc: "Legal na representasyon sa mga kasong sibil at alitan",
    service3Title: "Batas sa Pamilya",
    service3Desc: "Sensitibong legal na solusyon para sa pamilya at personal na status na mga usapin",
    service4Title: "Batas sa Real Estate",
    service4Desc: "Komprehensibong legal na serbisyo sa mga transaksyon sa real estate",
    service5Title: "Batas Kriminal",
    service5Desc: "Malakas at espesyalisadong depensa sa mga kasong kriminal",
    service6Title: "Batas sa Paggawa",
    service6Desc: "Proteksyon ng mga karapatan ng empleyado at employer",
    teamTitle: "Aming Legal na Koponan",
    teamSubtitle: "Espesyalisadong abogado at may karanasang legal na consultant",
    teamRole: "Tagapagtatag at Punong Abogado",
    teamBio: "Isang kilalang abogado na may malawak na karanasan sa iba't ibang larangan ng batas, nakatuon sa pagbibigay ng pinakamahusay na legal na serbisyo sa mga kliyente",
    testimonialsTitle: "Testimonya ng Kliyente",
    testimonialsSubtitle: "Ang tiwala ng aming mga kliyente ay aming pinakamalaking tagumpay",
    testimonial1: "Pambihira at napakahusay na propesyonal na legal na serbisyo. Tinulungan nila akong malutas ang aking kaso nang mahusay at propesyonal",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Negosyante",
    testimonial2: "Propesyonal at palakaibigan na koponan. Lubos na inirerekomenda ang kanilang natatanging legal na serbisyo",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Direktor ng Kumpanya",
    testimonial3: "Mahusay na kadalubhasaan sa legal at natatanging resulta. Salamat sa patuloy na suporta",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Namumuhunan",
    contactTitle: "Makipag-ugnayan sa Amin",
    contactSubtitle: "Nandito kami upang tumulong sa iyong legal na pangangailangan",
    contactName: "Buong Pangalan",
    contactEmail: "Email Address",
    contactPhone: "Numero ng Telepono",
    contactMessage: "Iyong Mensahe",
    contactButton: "Ipadala ang Mensahe",
    contactSuccess: "Ang iyong mensahe ay matagumpay na naipadala! Makikipag-ugnayan kami sa iyo sa lalong madaling panahon",
    footerAbout: "Tungkol sa Amin",
    footerAboutText: "Isang espesyalisadong law firm na nagbibigay ng komprehensibo at natatanging legal na serbisyo sa UAE",
    footerQuickLinks: "Mabilis na Link",
    footerContact: "Impormasyon sa Pakikipag-ugnayan",
    footerRights: "Lahat ng Karapatan ay Nakalaan",
    whyTitle: "Bakit Kami Piliin",
    whySubtitle: "Ang aming pangako sa kahusayan at propesyonalismo",
    why1Title: "Espesyalisadong Kadalubhasaan",
    why1Desc: "Koponan ng mga abogado na may malawak na karanasan",
    why2Title: "Napatunayang Resulta",
    why2Desc: "Talaan ng matagumpay na mga kaso",
    why3Title: "Personal na Pamamaraan",
    why3Desc: "Customized na legal na solusyon para sa bawat kliyente",
    why4Title: "Laging Available",
    why4Desc: "Patuloy na suporta at follow-up para sa aming mga kliyente"
  },
  gu: {
    home: "હોમ",
    about: "અમારા વિશે",
    services: "સેવાઓ",
    team: "ટીમ",
    testimonials: "પ્રશંસાપત્રો",
    contact: "સંપર્ક",
    heroTitle: "વિશ્વાસપાત્ર નિપુણતા સાથે કાનૂની ઉત્કૃષ્ટતા",
    heroSubtitle: "કાયદાના તમામ ક્ષેત્રોમાં વ્યાવસાયિક કાનૂની પરામર્શ અને પ્રતિનિધિત્વ",
    heroButton: "પરામર્શ બુક કરો",
    aboutTitle: "વકીલ ફાતિમા અબ્દુલકુદૂસ અલ ઓબેદલી વિશે",
    aboutDescription: "વ્યક્તિઓ અને વ્યવસાયો માટે વ્યાપક કાનૂની સેવાઓમાં વિશેષતા ધરાવતી UAE માં અગ્રણી કાયદા પેઢી. અમે ઉચ્ચતમ ધોરણો અનુસાર અસાધારણ કાનૂની પરામર્શ અને વ્યાવસાયિક પ્રતિનિધિત્વ પ્રદાન કરવામાં ગર્વ અનુભવીએ છીએ.",
    aboutYears: "વર્ષોનો અનુભવ",
    aboutCases: "સફળ કેસ",
    aboutClients: "સંતુષ્ટ ક્લાયન્ટ્સ",
    servicesTitle: "અમારી કાનૂની સેવાઓ",
    servicesSubtitle: "અમે વિશિષ્ટ કાનૂની સેવાઓની વ્યાપક શ્રેણી પ્રદાન કરીએ છીએ",
    service1Title: "વાણિજ્યિક કાયદો",
    service1Desc: "કંપનીઓ અને વ્યાપારી વ્યવસાયો માટે વ્યાપક કાનૂની પરામર્શ",
    service2Title: "નાગરિક કાયદો",
    service2Desc: "નાગરિક કેસ અને વિવાદોમાં કાનૂની પ્રતિનિધિત્વ",
    service3Title: "કૌટુંબિક કાયદો",
    service3Desc: "કૌટુંબિક અને વ્યક્તિગત સ્થિતિ બાબતો માટે સંવેદનશીલ કાનૂની ઉકેલો",
    service4Title: "રિયલ એસ્ટેટ કાયદો",
    service4Desc: "રિયલ એસ્ટેટ વ્યવહારોમાં વ્યાપક કાનૂની સેવાઓ",
    service5Title: "ફોજદારી કાયદો",
    service5Desc: "ફોજદારી કેસોમાં મજબૂત અને વિશિષ્ટ બચાવ",
    service6Title: "શ્રમ કાયદો",
    service6Desc: "કર્મચારી અને નોકરીદાતા અધિકારોનું રક્ષણ",
    teamTitle: "અમારી કાનૂની ટીમ",
    teamSubtitle: "વિશિષ્ટ વકીલો અને અનુભવી કાનૂની સલાહકારો",
    teamRole: "સ્થાપક અને મુખ્ય વકીલ",
    teamBio: "વિવિધ કાનૂની ક્ષેત્રોમાં વ્યાપક અનુભવ ધરાવતા પ્રતિષ્ઠિત વકીલ, ક્લાયન્ટ્સને શ્રેષ્ઠ કાનૂની સેવાઓ પ્રદાન કરવા માટે પ્રતિબદ્ધ",
    testimonialsTitle: "ક્લાયન્ટ પ્રશંસાપત્રો",
    testimonialsSubtitle: "અમારા ક્લાયન્ટ્સનો વિશ્વાસ અમારી સૌથી મોટી સિદ્ધિ છે",
    testimonial1: "અસાધારણ અને અત્યંત વ્યાવસાયિક કાનૂની સેવા. તેઓએ મને મારા કેસને કાર્યક્ષમ અને વ્યાવસાયિક રીતે ઉકેલવામાં મદદ કરી",
    testimonial1Name: "અહેમદ અલ મન્સૂરી",
    testimonial1Role: "વ્યાપારી",
    testimonial2: "વ્યાવસાયિક અને મૈત્રીપૂર્ણ ટીમ. તેમની ઉત્કૃષ્ટ કાનૂની સેવાઓની ખૂબ ભલામણ કરું છું",
    testimonial2Name: "સારાહ અલ શામસી",
    testimonial2Role: "કંપની ડિરેક્ટર",
    testimonial3: "ઉત્તમ કાનૂની નિપુણતા અને ઉત્તમ પરિણામો. સતત સમર્થન માટે આભાર",
    testimonial3Name: "મોહમ્મદ અલ કાબી",
    testimonial3Role: "રોકાણકાર",
    contactTitle: "અમારો સંપર્ક કરો",
    contactSubtitle: "અમે તમારી કાનૂની જરૂરિયાતોમાં મદદ કરવા માટે અહીં છીએ",
    contactName: "સંપૂર્ણ નામ",
    contactEmail: "ઈમેલ સરનામું",
    contactPhone: "ફોન નંબર",
    contactMessage: "તમારો સંદેશ",
    contactButton: "સંદેશ મોકલો",
    contactSuccess: "તમારો સંદેશ સફળતાપૂર્વક મોકલાયો! અમે ટૂંક સમયમાં તમારો સંપર્ક કરીશું",
    footerAbout: "અમારા વિશે",
    footerAboutText: "UAE માં વ્યાપક અને વિશિષ્ટ કાનૂની સેવાઓ પ્રદાન કરતી વિશિષ્ટ કાયદા પેઢી",
    footerQuickLinks: "ઝડપી લિંક્સ",
    footerContact: "સંપર્ક માહિતી",
    footerRights: "બધા અધિકારો અનામત",
    whyTitle: "શા માટે અમને પસંદ કરો",
    whySubtitle: "ઉત્કૃષ્ટતા અને વ્યાવસાયિકતા માટે અમારી પ્રતિબદ્ધતા",
    why1Title: "વિશિષ્ટ નિપુણતા",
    why1Desc: "વ્યાપક અનુભવ ધરાવતા વકીલોની ટીમ",
    why2Title: "સાબિત પરિણામો",
    why2Desc: "સફળ કેસોનો રેકોર્ડ",
    why3Title: "વ્યક્તિગત અભિગમ",
    why3Desc: "દરેક ક્લાયન્ટ માટે કસ્ટમાઇઝ્ડ કાનૂની ઉકેલો",
    why4Title: "હંમેશા ઉપલબ્ધ",
    why4Desc: "અમારા ક્લાયન્ટ્સ માટે સતત સમર્થન અને ફોલો-અપ"
  },
  it: {
    home: "Home",
    about: "Chi Siamo",
    services: "Servizi",
    team: "Team",
    testimonials: "Testimonianze",
    contact: "Contatti",
    heroTitle: "Eccellenza Legale con Competenza Affidabile",
    heroSubtitle: "Consulenza legale professionale e rappresentanza in tutti i settori del diritto",
    heroButton: "Prenota Consulenza",
    aboutTitle: "Informazioni sull'Avvocato Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Uno studio legale leader negli Emirati Arabi Uniti specializzato in servizi legali completi per privati e aziende. Siamo orgogliosi di fornire consulenza legale eccezionale e rappresentanza professionale ai massimi standard.",
    aboutYears: "Anni di Esperienza",
    aboutCases: "Casi di Successo",
    aboutClients: "Clienti Soddisfatti",
    servicesTitle: "I Nostri Servizi Legali",
    servicesSubtitle: "Offriamo una gamma completa di servizi legali specializzati",
    service1Title: "Diritto Commerciale",
    service1Desc: "Consulenza legale completa per aziende e imprese commerciali",
    service2Title: "Diritto Civile",
    service2Desc: "Rappresentanza legale in cause civili e controversie",
    service3Title: "Diritto di Famiglia",
    service3Desc: "Soluzioni legali sensibili per questioni familiari e di stato civile",
    service4Title: "Diritto Immobiliare",
    service4Desc: "Servizi legali completi nelle transazioni immobiliari",
    service5Title: "Diritto Penale",
    service5Desc: "Difesa forte e specializzata in casi penali",
    service6Title: "Diritto del Lavoro",
    service6Desc: "Protezione dei diritti dei dipendenti e dei datori di lavoro",
    teamTitle: "Il Nostro Team Legale",
    teamSubtitle: "Avvocati specializzati e consulenti legali esperti",
    teamRole: "Fondatrice e Avvocato Principale",
    teamBio: "Un avvocato distinto con vasta esperienza in vari settori legali, impegnato a fornire i migliori servizi legali ai clienti",
    testimonialsTitle: "Testimonianze dei Clienti",
    testimonialsSubtitle: "La fiducia dei nostri clienti è il nostro più grande successo",
    testimonial1: "Servizio legale eccezionale e altamente professionale. Mi hanno aiutato a risolvere il mio caso in modo efficiente e professionale",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Imprenditore",
    testimonial2: "Team professionale e cordiale. Raccomando vivamente i loro eccellenti servizi legali",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Direttore Aziendale",
    testimonial3: "Eccellente competenza legale e risultati eccezionali. Grazie per il supporto continuo",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Investitore",
    contactTitle: "Contattaci",
    contactSubtitle: "Siamo qui per aiutarti con le tue esigenze legali",
    contactName: "Nome Completo",
    contactEmail: "Indirizzo Email",
    contactPhone: "Numero di Telefono",
    contactMessage: "Il Tuo Messaggio",
    contactButton: "Invia Messaggio",
    contactSuccess: "Il tuo messaggio è stato inviato con successo! Ti contatteremo presto",
    footerAbout: "Chi Siamo",
    footerAboutText: "Uno studio legale specializzato che fornisce servizi legali completi e distinti negli Emirati Arabi Uniti",
    footerQuickLinks: "Link Rapidi",
    footerContact: "Informazioni di Contatto",
    footerRights: "Tutti i Diritti Riservati",
    whyTitle: "Perché Sceglierci",
    whySubtitle: "Il nostro impegno per l'eccellenza e la professionalità",
    why1Title: "Competenza Specializzata",
    why1Desc: "Team di avvocati con vasta esperienza",
    why2Title: "Risultati Comprovati",
    why2Desc: "Track record di casi di successo",
    why3Title: "Approccio Personale",
    why3Desc: "Soluzioni legali personalizzate per ogni cliente",
    why4Title: "Sempre Disponibili",
    why4Desc: "Supporto continuo e follow-up per i nostri clienti"
  },
  ne: {
    home: "गृहपृष्ठ",
    about: "हाम्रो बारेमा",
    services: "सेवाहरू",
    team: "टोली",
    testimonials: "प्रशंसापत्रहरू",
    contact: "सम्पर्क",
    heroTitle: "विश्वसनीय विशेषज्ञताको साथ कानुनी उत्कृष्टता",
    heroSubtitle: "कानूनका सबै क्षेत्रहरूमा व्यावसायिक कानुनी परामर्श र प्रतिनिधित्व",
    heroButton: "परामर्श बुक गर्नुहोस्",
    aboutTitle: "अधिवक्ता फातिमा अब्दुलकुदूस अल ओबेदली बारे",
    aboutDescription: "व्यक्ति र व्यवसायका लागि व्यापक कानुनी सेवाहरूमा विशेषज्ञता राख्ने UAE मा अग्रणी कानून फर्म। हामी उच्चतम मापदण्डमा असाधारण कानुनी परामर्श र व्यावसायिक प्रतिनिधित्व प्रदान गर्नमा गर्व गर्छौं।",
    aboutYears: "वर्षको अनुभव",
    aboutCases: "सफल मुद्दाहरू",
    aboutClients: "सन्तुष्ट ग्राहकहरू",
    servicesTitle: "हाम्रा कानुनी सेवाहरू",
    servicesSubtitle: "हामी विशेष कानुनी सेवाहरूको व्यापक दायरा प्रदान गर्दछौं",
    service1Title: "वाणिज्य कानून",
    service1Desc: "कम्पनीहरू र व्यापारिक व्यवसायका लागि व्यापक कानुनी परामर्श",
    service2Title: "नागरिक कानून",
    service2Desc: "नागरिक मुद्दा र विवादहरूमा कानुनी प्रतिनिधित्व",
    service3Title: "पारिवारिक कानून",
    service3Desc: "पारिवारिक र व्यक्तिगत स्थिति मामिलाहरूको लागि संवेदनशील कानुनी समाधान",
    service4Title: "घर जग्गा कानून",
    service4Desc: "घर जग्गा लेनदेनमा व्यापक कानुनी सेवाहरू",
    service5Title: "फौजदारी कानून",
    service5Desc: "फौजदारी मुद्दाहरूमा बलियो र विशेष प्रतिरक्षा",
    service6Title: "श्रम कानून",
    service6Desc: "कर्मचारी र रोजगारदाता अधिकारको संरक्षण",
    teamTitle: "हाम्रो कानुनी टोली",
    teamSubtitle: "विशेष अधिवक्ताहरू र अनुभवी कानुनी परामर्शदाताहरू",
    teamRole: "संस्थापक र प्रमुख अधिवक्ता",
    teamBio: "विभिन्न कानुनी क्षेत्रहरूमा व्यापक अनुभव भएको एक प्रतिष्ठित अधिवक्ता, ग्राहकहरूलाई उत्तम कानुनी सेवाहरू प्रदान गर्न प्रतिबद्ध",
    testimonialsTitle: "ग्राहक प्रशंसापत्रहरू",
    testimonialsSubtitle: "हाम्रा ग्राहकहरूको विश्वास हाम्रो सबैभन्दा ठूलो उपलब्धि हो",
    testimonial1: "असाधारण र अत्यधिक व्यावसायिक कानुनी सेवा। तिनीहरूले मलाई मेरो मुद्दा कुशलतापूर्वक र व्यावसायिक रूपमा समाधान गर्न मद्दत गरे",
    testimonial1Name: "अहमद अल मन्सूरी",
    testimonial1Role: "व्यवसायी",
    testimonial2: "व्यावसायिक र मैत्रीपूर्ण टोली। तिनीहरूको उत्कृष्ट कानुनी सेवाहरूको अत्यधिक सिफारिस गर्दछु",
    testimonial2Name: "सारा अल शामसी",
    testimonial2Role: "कम्पनी निर्देशक",
    testimonial3: "उत्कृष्ट कानुनी विशेषज्ञता र उत्कृष्ट परिणामहरू। निरन्तर समर्थनको लागि धन्यवाद",
    testimonial3Name: "मोहम्मद अल काबी",
    testimonial3Role: "लगानीकर्ता",
    contactTitle: "हामीलाई सम्पर्क गर्नुहोस्",
    contactSubtitle: "हामी तपाईंको कानुनी आवश्यकताहरूमा मद्दत गर्न यहाँ छौं",
    contactName: "पूरा नाम",
    contactEmail: "इमेल ठेगाना",
    contactPhone: "फोन नम्बर",
    contactMessage: "तपाईंको सन्देश",
    contactButton: "सन्देश पठाउनुहोस्",
    contactSuccess: "तपाईंको सन्देश सफलतापूर्वक पठाइयो! हामी चाँडै तपाईंलाई सम्पर्क गर्नेछौं",
    footerAbout: "हाम्रो बारेमा",
    footerAboutText: "UAE मा व्यापक र विशिष्ट कानुनी सेवाहरू प्रदान गर्ने एक विशेष कानून फर्म",
    footerQuickLinks: "द्रुत लिङ्कहरू",
    footerContact: "सम्पर्क जानकारी",
    footerRights: "सबै अधिकार सुरक्षित",
    whyTitle: "किन हामीलाई छनौट गर्ने",
    whySubtitle: "उत्कृष्टता र व्यावसायिकताप्रति हाम्रो प्रतिबद्धता",
    why1Title: "विशेष विशेषज्ञता",
    why1Desc: "व्यापक अनुभव भएका अधिवक्ताहरूको टोली",
    why2Title: "प्रमाणित परिणामहरू",
    why2Desc: "सफल मुद्दाहरूको रेकर्ड",
    why3Title: "व्यक्तिगत दृष्टिकोण",
    why3Desc: "प्रत्येक ग्राहकको लागि अनुकूलित कानुनी समाधान",
    why4Title: "सधैं उपलब्ध",
    why4Desc: "हाम्रा ग्राहकहरूको लागि निरन्तर समर्थन र फलोअप"
  },
  fa: {
    home: "خانه",
    about: "درباره ما",
    services: "خدمات",
    team: "تیم",
    testimonials: "توصیفات",
    contact: "تماس",
    heroTitle: "تعالی حقوقی با تخصص قابل اعتماد",
    heroSubtitle: "مشاوره حقوقی حرفه‌ای و نمایندگی در تمام زمینه‌های قانون",
    heroButton: "رزرو مشاوره",
    aboutTitle: "درباره وکیل فاطمه عبدالقدوس العبیدلی",
    aboutDescription: "یک شرکت حقوقی پیشرو در امارات متحده عربی متخصص در خدمات حقوقی جامع برای افراد و کسب‌وکارها. ما به ارائه مشاوره حقوقی استثنایی و نمایندگی حرفه‌ای با بالاترین استانداردها افتخار می‌کنیم.",
    aboutYears: "سال تجربه",
    aboutCases: "پرونده‌های موفق",
    aboutClients: "مشتریان راضی",
    servicesTitle: "خدمات حقوقی ما",
    servicesSubtitle: "ما طیف جامعی از خدمات حقوقی تخصصی ارائه می‌دهیم",
    service1Title: "حقوق تجاری",
    service1Desc: "مشاوره حقوقی جامع برای شرکت‌ها و کسب‌وکارهای تجاری",
    service2Title: "حقوق مدنی",
    service2Desc: "نمایندگی حقوقی در پرونده‌های مدنی و اختلافات",
    service3Title: "حقوق خانواده",
    service3Desc: "راه‌حل‌های حقوقی حساس برای مسائل خانوادگی و وضعیت شخصی",
    service4Title: "حقوق املاک",
    service4Desc: "خدمات حقوقی جامع در معاملات املاک",
    service5Title: "حقوق جزا",
    service5Desc: "دفاع قوی و تخصصی در پرونده‌های کیفری",
    service6Title: "حقوق کار",
    service6Desc: "حمایت از حقوق کارمندان و کارفرمایان",
    teamTitle: "تیم حقوقی ما",
    teamSubtitle: "وکلای متخصص و مشاوران حقوقی با تجربه",
    teamRole: "بنیانگذار و وکیل ارشد",
    teamBio: "یک وکیل برجسته با تجربه گسترده در زمینه‌های مختلف حقوقی، متعهد به ارائه بهترین خدمات حقوقی به مشتریان",
    testimonialsTitle: "توصیفات مشتریان",
    testimonialsSubtitle: "اعتماد مشتریان ما بزرگترین دستاورد ماست",
    testimonial1: "خدمات حقوقی استثنایی و بسیار حرفه‌ای. آن‌ها به من کمک کردند پرونده‌ام را به طور کارآمد و حرفه‌ای حل کنم",
    testimonial1Name: "احمد المنصوری",
    testimonial1Role: "تاجر",
    testimonial2: "تیم حرفه‌ای و دوستانه. خدمات حقوقی عالی آن‌ها را به شدت توصیه می‌کنم",
    testimonial2Name: "سارا الشامسی",
    testimonial2Role: "مدیر شرکت",
    testimonial3: "تخصص حقوقی عالی و نتایج برجسته. از حمایت مداوم متشکریم",
    testimonial3Name: "محمد الکعبی",
    testimonial3Role: "سرمایه‌گذار",
    contactTitle: "با ما تماس بگیرید",
    contactSubtitle: "ما اینجا هستیم تا در نیازهای حقوقی شما کمک کنیم",
    contactName: "نام کامل",
    contactEmail: "آدرس ایمیل",
    contactPhone: "شماره تلفن",
    contactMessage: "پیام شما",
    contactButton: "ارسال پیام",
    contactSuccess: "پیام شما با موفقیت ارسال شد! به زودی با شما تماس خواهیم گرفت",
    footerAbout: "درباره ما",
    footerAboutText: "یک شرکت حقوقی تخصصی که خدمات حقوقی جامع و متمایز در امارات ارائه می‌دهد",
    footerQuickLinks: "لینک‌های سریع",
    footerContact: "اطلاعات تماس",
    footerRights: "تمام حقوق محفوظ است",
    whyTitle: "چرا ما را انتخاب کنید",
    whySubtitle: "تعهد ما به تعالی و حرفه‌ای گری",
    why1Title: "تخصص ویژه",
    why1Desc: "تیمی از وکلا با تجربه گسترده",
    why2Title: "نتایج اثبات شده",
    why2Desc: "سابقه پرونده‌های موفق",
    why3Title: "رویکرد شخصی",
    why3Desc: "راه‌حل‌های حقوقی سفارشی برای هر مشتری",
    why4Title: "همیشه در دسترس",
    why4Desc: "پشتیبانی و پیگیری مستمر برای مشتریان ما"
  },
  pa: {
    home: "ਘਰ",
    about: "ਸਾਡੇ ਬਾਰੇ",
    services: "ਸੇਵਾਵਾਂ",
    team: "ਟੀਮ",
    testimonials: "ਸਿਫ਼ਾਰਿਸ਼ਾਂ",
    contact: "ਸੰਪਰਕ",
    heroTitle: "ਭਰੋਸੇਮੰਦ ਮਾਹਰਤਾ ਨਾਲ ਕਾਨੂੰਨੀ ਉੱਤਮਤਾ",
    heroSubtitle: "ਕਾਨੂੰਨ ਦੇ ਸਾਰੇ ਖੇਤਰਾਂ ਵਿੱਚ ਪੇਸ਼ੇਵਰ ਕਾਨੂੰਨੀ ਸਲਾਹ ਅਤੇ ਪ੍ਰਤੀਨਿਧਤਾ",
    heroButton: "ਸਲਾਹ ਬੁੱਕ ਕਰੋ",
    aboutTitle: "ਵਕੀਲ ਫਾਤਿਮਾ ਅਬਦੁਲਕੁਦੂਸ ਅਲ ਓਬੈਦਲੀ ਬਾਰੇ",
    aboutDescription: "ਯੂਏਈ ਵਿੱਚ ਇੱਕ ਮੋਹਰੀ ਕਾਨੂੰਨ ਫਰਮ ਜੋ ਵਿਅਕਤੀਆਂ ਅਤੇ ਕਾਰੋਬਾਰਾਂ ਲਈ ਵਿਆਪਕ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਵਿੱਚ ਮੁਹਾਰਤ ਰੱਖਦੀ ਹੈ। ਅਸੀਂ ਉੱਚਤਮ ਮਿਆਰਾਂ ਲਈ ਬੇਮਿਸਾਲ ਕਾਨੂੰਨੀ ਸਲਾਹ ਅਤੇ ਪੇਸ਼ੇਵਰ ਪ੍ਰਤੀਨਿਧਤਾ ਪ੍ਰਦਾਨ ਕਰਨ 'ਤੇ ਮਾਣ ਕਰਦੇ ਹਾਂ।",
    aboutYears: "ਸਾਲ ਦਾ ਤਜਰਬਾ",
    aboutCases: "ਸਫਲ ਕੇਸ",
    aboutClients: "ਸੰਤੁਸ਼ਟ ਗਾਹਕ",
    servicesTitle: "ਸਾਡੀਆਂ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ",
    servicesSubtitle: "ਅਸੀਂ ਵਿਸ਼ੇਸ਼ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਦੀ ਵਿਆਪਕ ਸ਼੍ਰੇਣੀ ਪੇਸ਼ ਕਰਦੇ ਹਾਂ",
    service1Title: "ਵਪਾਰਕ ਕਾਨੂੰਨ",
    service1Desc: "ਕੰਪਨੀਆਂ ਅਤੇ ਵਪਾਰਕ ਕਾਰੋਬਾਰਾਂ ਲਈ ਵਿਆਪਕ ਕਾਨੂੰਨੀ ਸਲਾਹ",
    service2Title: "ਸਿਵਲ ਕਾਨੂੰਨ",
    service2Desc: "ਸਿਵਲ ਕੇਸਾਂ ਅਤੇ ਵਿਵਾਦਾਂ ਵਿੱਚ ਕਾਨੂੰਨੀ ਪ੍ਰਤੀਨਿਧਤਾ",
    service3Title: "ਪਰਿਵਾਰਕ ਕਾਨੂੰਨ",
    service3Desc: "ਪਰਿਵਾਰਕ ਅਤੇ ਨਿੱਜੀ ਸਥਿਤੀ ਦੇ ਮਾਮਲਿਆਂ ਲਈ ਸੰਵੇਦਨਸ਼ੀਲ ਕਾਨੂੰਨੀ ਹੱਲ",
    service4Title: "ਰੀਅਲ ਅਸਟੇਟ ਕਾਨੂੰਨ",
    service4Desc: "ਰੀਅਲ ਅਸਟੇਟ ਲੈਣ-ਦੇਣ ਵਿੱਚ ਵਿਆਪਕ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ",
    service5Title: "ਫੌਜਦਾਰੀ ਕਾਨੂੰਨ",
    service5Desc: "ਫੌਜਦਾਰੀ ਕੇਸਾਂ ਵਿੱਚ ਮਜ਼ਬੂਤ ਅਤੇ ਵਿਸ਼ੇਸ਼ ਬਚਾਅ",
    service6Title: "ਮਜ਼ਦੂਰ ਕਾਨੂੰਨ",
    service6Desc: "ਕਰਮਚਾਰੀ ਅਤੇ ਮਾਲਕ ਅਧਿਕਾਰਾਂ ਦੀ ਸੁਰੱਖਿਆ",
    teamTitle: "ਸਾਡੀ ਕਾਨੂੰਨੀ ਟੀਮ",
    teamSubtitle: "ਵਿਸ਼ੇਸ਼ ਵਕੀਲ ਅਤੇ ਤਜਰਬੇਕਾਰ ਕਾਨੂੰਨੀ ਸਲਾਹਕਾਰ",
    teamRole: "ਸੰਸਥਾਪਕ ਅਤੇ ਮੁੱਖ ਵਕੀਲ",
    teamBio: "ਵੱਖ-ਵੱਖ ਕਾਨੂੰਨੀ ਖੇਤਰਾਂ ਵਿੱਚ ਵਿਆਪਕ ਤਜਰਬੇ ਵਾਲੇ ਇੱਕ ਪ੍ਰਤਿਸ਼ਠਤ ਵਕੀਲ, ਗਾਹਕਾਂ ਨੂੰ ਸਭ ਤੋਂ ਵਧੀਆ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਨ ਲਈ ਵਚਨਬੱਧ",
    testimonialsTitle: "ਗਾਹਕ ਸਿਫ਼ਾਰਿਸ਼ਾਂ",
    testimonialsSubtitle: "ਸਾਡੇ ਗਾਹਕਾਂ ਦਾ ਭਰੋਸਾ ਸਾਡੀ ਸਭ ਤੋਂ ਵੱਡੀ ਪ੍ਰਾਪਤੀ ਹੈ",
    testimonial1: "ਬੇਮਿਸਾਲ ਅਤੇ ਬਹੁਤ ਹੀ ਪੇਸ਼ੇਵਰ ਕਾਨੂੰਨੀ ਸੇਵਾ। ਉਨ੍ਹਾਂ ਨੇ ਮੇਰੇ ਕੇਸ ਨੂੰ ਕੁਸ਼ਲਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰਾਨਾ ਢੰਗ ਨਾਲ ਹੱਲ ਕਰਨ ਵਿੱਚ ਮੇਰੀ ਮਦਦ ਕੀਤੀ",
    testimonial1Name: "ਅਹਿਮਦ ਅਲ ਮਨਸੂਰੀ",
    testimonial1Role: "ਵਪਾਰੀ",
    testimonial2: "ਪੇਸ਼ੇਵਰ ਅਤੇ ਦੋਸਤਾਨਾ ਟੀਮ। ਉਨ੍ਹਾਂ ਦੀਆਂ ਸ਼ਾਨਦਾਰ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਦੀ ਬਹੁਤ ਸਿਫ਼ਾਰਿਸ਼ ਕਰਦਾ ਹਾਂ",
    testimonial2Name: "ਸਾਰਾ ਅਲ ਸ਼ਾਮਸੀ",
    testimonial2Role: "ਕੰਪਨੀ ਡਾਇਰੈਕਟਰ",
    testimonial3: "ਸ਼ਾਨਦਾਰ ਕਾਨੂੰਨੀ ਮੁਹਾਰਤ ਅਤੇ ਸ਼ਾਨਦਾਰ ਨਤੀਜੇ। ਲਗਾਤਾਰ ਸਹਾਇਤਾ ਲਈ ਧੰਨਵਾਦ",
    testimonial3Name: "ਮੁਹੰਮਦ ਅਲ ਕਾਬੀ",
    testimonial3Role: "ਨਿਵੇਸ਼ਕ",
    contactTitle: "ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    contactSubtitle: "ਅਸੀਂ ਤੁਹਾਡੀਆਂ ਕਾਨੂੰਨੀ ਲੋੜਾਂ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਇੱਥੇ ਹਾਂ",
    contactName: "ਪੂਰਾ ਨਾਮ",
    contactEmail: "ਈਮੇਲ ਪਤਾ",
    contactPhone: "ਫ਼ੋਨ ਨੰਬਰ",
    contactMessage: "ਤੁਹਾਡਾ ਸੁਨੇਹਾ",
    contactButton: "ਸੁਨੇਹਾ ਭੇਜੋ",
    contactSuccess: "ਤੁਹਾਡਾ ਸੁਨੇਹਾ ਸਫਲਤਾਪੂਰਵਕ ਭੇਜਿਆ ਗਿਆ! ਅਸੀਂ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਾਂਗੇ",
    footerAbout: "ਸਾਡੇ ਬਾਰੇ",
    footerAboutText: "ਇੱਕ ਵਿਸ਼ੇਸ਼ ਕਾਨੂੰਨ ਫਰਮ ਜੋ ਯੂਏਈ ਵਿੱਚ ਵਿਆਪਕ ਅਤੇ ਵਿਲੱਖਣ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ",
    footerQuickLinks: "ਤੇਜ਼ ਲਿੰਕ",
    footerContact: "ਸੰਪਰਕ ਜਾਣਕਾਰੀ",
    footerRights: "ਸਾਰੇ ਅਧਿਕਾਰ ਰਾਖਵੇਂ ਹਨ",
    whyTitle: "ਸਾਨੂੰ ਕਿਉਂ ਚੁਣੋ",
    whySubtitle: "ਉੱਤਮਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰਤਾ ਲਈ ਸਾਡੀ ਵਚਨਬੱਧਤਾ",
    why1Title: "ਵਿਸ਼ੇਸ਼ ਮੁਹਾਰਤ",
    why1Desc: "ਵਿਆਪਕ ਤਜਰਬੇ ਵਾਲੇ ਵਕੀਲਾਂ ਦੀ ਟੀਮ",
    why2Title: "ਸਾਬਤ ਨਤੀਜੇ",
    why2Desc: "ਸਫਲ ਕੇਸਾਂ ਦਾ ਰਿਕਾਰਡ",
    why3Title: "ਨਿੱਜੀ ਪਹੁੰਚ",
    why3Desc: "ਹਰੇਕ ਗਾਹਕ ਲਈ ਅਨੁਕੂਲਿਤ ਕਾਨੂੰਨੀ ਹੱਲ",
    why4Title: "ਹਮੇਸ਼ਾ ਉਪਲਬਧ",
    why4Desc: "ਸਾਡੇ ਗਾਹਕਾਂ ਲਈ ਨਿਰੰਤਰ ਸਹਾਇਤਾ ਅਤੇ ਫਾਲੋ-ਅੱਪ"
  },
  pt: {
    home: "Início",
    about: "Sobre Nós",
    services: "Serviços",
    team: "Equipa",
    testimonials: "Testemunhos",
    contact: "Contacto",
    heroTitle: "Excelência Jurídica com Experiência Confiável",
    heroSubtitle: "Consultoria jurídica profissional e representação em todas as áreas do direito",
    heroButton: "Reservar Consulta",
    aboutTitle: "Sobre a Advogada Fatima Abdulqudous Al Obeidli",
    aboutDescription: "Um escritório de advocacia líder nos EAU, especializado em serviços jurídicos abrangentes para indivíduos e empresas. Orgulhamo-nos de fornecer consultoria jurídica excecional e representação profissional aos mais altos padrões.",
    aboutYears: "Anos de Experiência",
    aboutCases: "Casos Bem-Sucedidos",
    aboutClients: "Clientes Satisfeitos",
    servicesTitle: "Os Nossos Serviços Jurídicos",
    servicesSubtitle: "Oferecemos uma gama abrangente de serviços jurídicos especializados",
    service1Title: "Direito Comercial",
    service1Desc: "Consultoria jurídica abrangente para empresas e negócios comerciais",
    service2Title: "Direito Civil",
    service2Desc: "Representação jurídica em casos civis e disputas",
    service3Title: "Direito da Família",
    service3Desc: "Soluções jurídicas sensíveis para questões familiares e de estado civil",
    service4Title: "Direito Imobiliário",
    service4Desc: "Serviços jurídicos abrangentes em transações imobiliárias",
    service5Title: "Direito Penal",
    service5Desc: "Defesa forte e especializada em casos criminais",
    service6Title: "Direito do Trabalho",
    service6Desc: "Proteção dos direitos dos empregados e empregadores",
    teamTitle: "A Nossa Equipa Jurídica",
    teamSubtitle: "Advogados especializados e consultores jurídicos experientes",
    teamRole: "Fundadora e Advogada Principal",
    teamBio: "Uma advogada distinta com vasta experiência em várias áreas jurídicas, comprometida em fornecer os melhores serviços jurídicos aos clientes",
    testimonialsTitle: "Testemunhos de Clientes",
    testimonialsSubtitle: "A confiança dos nossos clientes é a nossa maior conquista",
    testimonial1: "Serviço jurídico excecional e altamente profissional. Ajudaram-me a resolver o meu caso de forma eficiente e profissional",
    testimonial1Name: "Ahmed Al Mansoori",
    testimonial1Role: "Empresário",
    testimonial2: "Equipa profissional e amigável. Recomendo vivamente os seus excelentes serviços jurídicos",
    testimonial2Name: "Sarah Al Shamsi",
    testimonial2Role: "Diretora de Empresa",
    testimonial3: "Excelente experiência jurídica e resultados excecionais. Obrigado pelo apoio contínuo",
    testimonial3Name: "Mohammed Al Kaabi",
    testimonial3Role: "Investidor",
    contactTitle: "Contacte-nos",
    contactSubtitle: "Estamos aqui para ajudar com as suas necessidades jurídicas",
    contactName: "Nome Completo",
    contactEmail: "Endereço de Email",
    contactPhone: "Número de Telefone",
    contactMessage: "A Sua Mensagem",
    contactButton: "Enviar Mensagem",
    contactSuccess: "A sua mensagem foi enviada com sucesso! Entraremos em contacto em breve",
    footerAbout: "Sobre Nós",
    footerAboutText: "Um escritório de advocacia especializado que fornece serviços jurídicos abrangentes e distintos nos EAU",
    footerQuickLinks: "Links Rápidos",
    footerContact: "Informações de Contacto",
    footerRights: "Todos os Direitos Reservados",
    whyTitle: "Porquê Escolher-nos",
    whySubtitle: "O nosso compromisso com a excelência e profissionalismo",
    why1Title: "Experiência Especializada",
    why1Desc: "Equipa de advogados com vasta experiência",
    why2Title: "Resultados Comprovados",
    why2Desc: "Historial de casos bem-sucedidos",
    why3Title: "Abordagem Pessoal",
    why3Desc: "Soluções jurídicas personalizadas para cada cliente",
    why4Title: "Sempre Disponível",
    why4Desc: "Apoio contínuo e acompanhamento para os nossos clientes"
  },
  si: {
    home: "මුල් පිටුව",
    about: "අප ගැන",
    services: "සේවා",
    team: "කණ්ඩායම",
    testimonials: "සහතික",
    contact: "අමතන්න",
    heroTitle: "විශ්වාසදායක ප්‍රවීණත්වය සමඟ නීතිමය විශිෂ්ටත්වය",
    heroSubtitle: "නීතියේ සියලු ක්ෂේත්‍රවල වෘත්තීය නීති උපදේශන සහ නියෝජනය",
    heroButton: "උපදේශන වෙන්කරවා ගන්න",
    aboutTitle: "නීතිඥ ෆාතිමා අබ්දුල්කුදූස් අල් ඔබෙයිඩ්ලි ගැන",
    aboutDescription: "පුද්ගලයන් සහ ව්‍යාපාර සඳහා විස්තීර්ණ නීති සේවා පිළිබඳ විශේෂඥ UAE හි ප්‍රමුඛ නීති සමාගමකි. අපි ඉහළම ප්‍රමිතීන්ට අනුකූලව සුවිශේෂී නීති උපදේශන සහ වෘත්තීය නියෝජනය සැපයීම ගැන ආඩම්බරයෙන් සිටිමු.",
    aboutYears: "අවුරුදු අත්දැකීම්",
    aboutCases: "සාර්ථක නඩු",
    aboutClients: "තෘප්තිමත් සේවාදායකයන්",
    servicesTitle: "අපගේ නීති සේවා",
    servicesSubtitle: "අපි විශේෂිත නීති සේවාවන්ගේ විස්තීර්ණ පරාසයක් පිරිනමන්නෙමු",
    service1Title: "වාණිජ නීතිය",
    service1Desc: "සමාගම් සහ වාණිජ ව්‍යාපාර සඳහා විස්තීර්ණ නීති උපදේශන",
    service2Title: "සිවිල් නීතිය",
    service2Desc: "සිවිල් නඩු සහ ආරවුල්වල නීති නියෝජනය",
    service3Title: "පවුල් නීතිය",
    service3Desc: "පවුල් සහ පෞද්ගලික තත්ත්ව කරුණු සඳහා සංවේදී නීති විසඳුම්",
    service4Title: "දේපළ නීතිය",
    service4Desc: "දේපළ ගනුදෙනුවල විස්තීර්ණ නීති සේවා",
    service5Title: "අපරාධ නීතිය",
    service5Desc: "අපරාධ නඩුවල ශක්තිමත් සහ විශේෂිත ආරක්ෂාව",
    service6Title: "කම්කරු නීතිය",
    service6Desc: "සේවක සහ සේවායෝජක අයිතිවාසිකම් ආරක්ෂා කිරීම",
    teamTitle: "අපගේ නීති කණ්ඩායම",
    teamSubtitle: "විශේෂිත නීතිඥයින් සහ අත්දැකීම් ඇති නීති උපදේශකයින්",
    teamRole: "නිර්මාතෘ සහ ප්‍රධාන නීතිඥ",
    teamBio: "විවිධ නීති ක්ෂේත්‍රවල පුළුල් අත්දැකීම් ඇති කීර්තිමත් නීතිඥයෙකු, සේවාදායකයන්ට හොඳම නීති සේවා සැපයීමට කැපවී සිටී",
    testimonialsTitle: "සේවාදායක සහතික",
    testimonialsSubtitle: "අපගේ සේවාදායකයන්ගේ විශ්වාසය අපගේ විශාලතම ජයග්‍රහණයයි",
    testimonial1: "සුවිශේෂී සහ ඉතා වෘත්තීය නීති සේවාවක්. ඔවුන් මගේ නඩුව කාර්යක්ෂමව සහ වෘත්තීයව විසඳීමට මට උදව් කළා",
    testimonial1Name: "අහමඩ් අල් මන්සූරි",
    testimonial1Role: "ව්‍යාපාරික",
    testimonial2: "වෘත්තීය සහ මිත්‍රශීලී කණ්ඩායමක්. ඔවුන්ගේ විශිෂ්ට නීති සේවා දැඩිව නිර්දේශ කරමි",
    testimonial2Name: "සාරා අල් ෂම්සි",
    testimonial2Role: "සමාගම අධ්‍යක්ෂ",
    testimonial3: "විශිෂ්ට නීති ප්‍රවීණත්වය සහ විශිෂ්ට ප්‍රතිඵල. අඛණ්ඩ සහයෝගය ගැන ස්තූතියි",
    testimonial3Name: "මොහොමඩ් අල් කාබි",
    testimonial3Role: "ආයෝජකයා",
    contactTitle: "අප අමතන්න",
    contactSubtitle: "ඔබගේ නීති අවශ්‍යතා සඳහා උදව් කිරීමට අපි මෙහි සිටිමු",
    contactName: "සම්පූර්ණ නම",
    contactEmail: "විද්‍යුත් ලිපිනය",
    contactPhone: "දුරකථන අංකය",
    contactMessage: "ඔබගේ පණිවිඩය",
    contactButton: "පණිවිඩය යවන්න",
    contactSuccess: "ඔබගේ පණිවිඩය සාර්ථකව යවන ලදී! අපි ඉක්මනින් ඔබව අමතන්නෙමු",
    footerAbout: "අප ගැන",
    footerAboutText: "UAE හි විස්තීර්ණ සහ විශිෂ්ට නීති සේවා සපයන විශේෂිත නීති සමාගමක්",
    footerQuickLinks: "ඉක්මන් සබැඳි",
    footerContact: "සම්බන්ධතා තොරතුරු",
    footerRights: "සියලු හිමිකම් ඇවිරිණි",
    whyTitle: "අපව තෝරා ගන්නේ ඇයි",
    whySubtitle: "විශිෂ්ටත්වය සහ වෘත්තීයත්වය සඳහා අපගේ කැපවීම",
    why1Title: "විශේෂිත ප්‍රවීණත්වය",
    why1Desc: "පුළුල් අත්දැකීම් ඇති නීතිඥයන්ගේ කණ්ඩායම",
    why2Title: "ඔප්පු කරන ලද ප්‍රතිඵල",
    why2Desc: "සාර්ථක නඩු වාර්තාව",
    why3Title: "පුද්ගලික ප්‍රවේශය",
    why3Desc: "සෑම සේවාදායකයෙකු සඳහාම අභිරුචිකරණය කළ නීති විසඳුම්",
    why4Title: "සැමවිටම ලබා ගත හැකිය",
    why4Desc: "අපගේ සේවාදායකයන් සඳහා අඛණ්ඩ සහාය සහ පසු විපරම"
  },
  te: {
    home: "హోమ్",
    about: "మా గురించి",
    services: "సేవలు",
    team: "బృందం",
    testimonials: "సాక్ష్యాలు",
    contact: "సంప్రదించండి",
    heroTitle: "విశ్వసనీయ నైపుణ్యంతో చట్టపరమైన శ్రేష్ఠత",
    heroSubtitle: "చట్టం యొక్క అన్ని రంగాలలో వృత్తిపరమైన న్యాయ సలహా మరియు ప్రాతినిధ్యం",
    heroButton: "సలహా బుక్ చేయండి",
    aboutTitle: "న్యాయవాది ఫాతిమా అబ్దుల్కుదూస్ అల్ ఒబైదిలి గురించి",
    aboutDescription: "వ్యక్తులు మరియు వ్యాపారాల కోసం సమగ్ర న్యాయ సేవలలో నైపుణ్యం కలిగిన UAE లో ప్రముఖ న్యాయ సంస్థ. అత్యున్నత ప్రమాణాలకు అసాధారణమైన న్యాయ సలహా మరియు వృత్తిపరమైన ప్రాతినిధ్యం అందించడంలో మేము గర్విస్తున్నాము.",
    aboutYears: "సంవత్సరాల అనుభవం",
    aboutCases: "విజయవంతమైన కేసులు",
    aboutClients: "సంతృప్తి చెందిన క్లయింట్లు",
    servicesTitle: "మా న్యాయ సేవలు",
    servicesSubtitle: "మేము ప్రత్యేక న్యాయ సేవల విస్తృత శ్రేణిని అందిస్తున్నాము",
    service1Title: "వాణిజ్య చట్టం",
    service1Desc: "కంపెనీలు మరియు వాణిజ్య వ్యాపారాల కోసం సమగ్ర న్యాయ సలహా",
    service2Title: "సివిల్ చట్టం",
    service2Desc: "సివిల్ కేసులు మరియు వివాదాలలో న్యాయ ప్రాతినిధ్యం",
    service3Title: "కుటుంబ చట్టం",
    service3Desc: "కుటుంబం మరియు వ్యక్తిగత స్థితి విషయాల కోసం సున్నితమైన న్యాయ పరిష్కారాలు",
    service4Title: "రియల్ ఎస్టేట్ చట్టం",
    service4Desc: "రియల్ ఎస్టేట్ లావాదేవీలలో సమగ్ర న్యాయ సేవలు",
    service5Title: "క్రిమినల్ చట్టం",
    service5Desc: "క్రిమినల్ కేసులలో బలమైన మరియు ప్రత్యేక రక్షణ",
    service6Title: "కార్మిక చట్టం",
    service6Desc: "ఉద్యోగి మరియు యజమాని హక్కుల రక్షణ",
    teamTitle: "మా న్యాయ బృందం",
    teamSubtitle: "ప్రత్యేక న్యాయవాదులు మరియు అనుభవజ్ఞులైన న్యాయ సలహాదారులు",
    teamRole: "వ్యవస్థాపకురాలు మరియు ప్రధాన న్యాయవాది",
    teamBio: "వివిధ న్యాయ రంగాలలో విస్తృత అనుభవం కలిగిన ప్రముఖ న్యాయవాది, క్లయింట్లకు ఉత్తమ న్యాయ సేవలను అందించడానికి కట్టుబడి ఉన్నారు",
    testimonialsTitle: "క్లయింట్ సాక్ష్యాలు",
    testimonialsSubtitle: "మా క్లయింట్ల నమ్మకం మా గొప్ప విజయం",
    testimonial1: "అసాధారణమైన మరియు అత్యంత వృత్తిపరమైన న్యాయ సేవ. వారు నా కేసును సమర్థవంతంగా మరియు వృత్తిపరంగా పరిష్కరించడంలో నాకు సహాయపడ్డారు",
    testimonial1Name: "అహ్మద్ అల్ మన్సూరీ",
    testimonial1Role: "వ్యాపారవేత్త",
    testimonial2: "వృత్తిపరమైన మరియు స్నేహపూర్వక బృందం. వారి అద్భుతమైన న్యాయ సేవలను బాగా సిఫార్సు చేస్తున్నాను",
    testimonial2Name: "సారా అల్ షమ్సీ",
    testimonial2Role: "కంపెనీ డైరెక్టర్",
    testimonial3: "అద్భుతమైన న్యాయ నైపుణ్యం మరియు అద్భుతమైన ఫలితాలు. నిరంతర మద్దతు కోసం ధన్యవాదాలు",
    testimonial3Name: "మొహమ్మద్ అల్ కాబీ",
    testimonial3Role: "పెట్టుబడిదారు",
    contactTitle: "మమ్మల్ని సంప్రదించండి",
    contactSubtitle: "మీ న్యాయ అవసరాలలో సహాయం చేయడానికి మేము ఇక్కడ ఉన్నాము",
    contactName: "పూర్తి పేరు",
    contactEmail: "ఇమెయిల్ చిరునామా",
    contactPhone: "ఫోన్ నంబర్",
    contactMessage: "మీ సందేశం",
    contactButton: "సందేశం పంపండి",
    contactSuccess: "మీ సందేశం విజయవంతంగా పంపబడింది! మేము త్వరలో మిమ్మల్ని సంప్రదిస్తాము",
    footerAbout: "మా గురించి",
    footerAboutText: "UAE లో సమగ్ర మరియు విశిష్ట న్యాయ సేవలను అందించే ప్రత్యేక న్యాయ సంస్థ",
    footerQuickLinks: "త్వరిత లింక్‌లు",
    footerContact: "సంప్రదింపు సమాచారం",
    footerRights: "అన్ని హక్కులూ రిజర్వ్ చేయబడ్డాయి",
    whyTitle: "మమ్మల్ని ఎందుకు ఎంచుకోవాలి",
    whySubtitle: "శ్రేష్ఠత మరియు వృత్తిపరత్వం పట్ల మా నిబద్ధత",
    why1Title: "ప్రత్యేక నైపుణ్యం",
    why1Desc: "విస్తృత అనుభవం కలిగిన న్యాయవాదుల బృందం",
    why2Title: "నిరూపితమైన ఫలితాలు",
    why2Desc: "విజయవంతమైన కేసుల రికార్డు",
    why3Title: "వ్యక్తిగత విధానం",
    why3Desc: "ప్రతి క్లయింట్ కోసం అనుకూలీకరించిన న్యాయ పరిష్కారాలు",
    why4Title: "ఎల్లప్పుడూ అందుబాటులో",
    why4Desc: "మా క్లయింట్ల కోసం నిరంతర మద్దతు మరియు ఫాలో-అప్"
  }
};

export const images = {
  hero: "https://images.unsplash.com/photo-1699621106755-4fe40ce95d64",
  about: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da",
  consultation: "https://customer-assets.emergentagent.com/job_75532057-c4b9-447a-8d40-84951b09abfd/artifacts/i6omi4xn_IMG_8449.jpeg",
  office: "https://images.unsplash.com/photo-1568115286680-d203e08a8be6",
  justice: "https://images.unsplash.com/photo-1760089449852-e8cade7feb53",
  gavel: "https://images.unsplash.com/photo-1767972159871-b9f5d320be2b",
  library: "https://images.unsplash.com/photo-1505664194779-8beaceb93744",
  meeting: "https://images.unsplash.com/photo-1571624436279-b272aff752b5"
};
